// Generated from /builds/tableau-expression/tableau-expression-parser-js/build/nerv-resources/resources/TableauExpression.g4 by ANTLR 4.12.0
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
import { ATN, ATNDeserializer, DFA, FailedPredicateException, RecognitionException, NoViableAltException, Parser, ParserATNSimulator, ParserRuleContext, PredictionContextCache, Token } from 'antlr4';
export default class TableauExpressionParser extends Parser {
    constructor(input) {
        super(input);
        this._interp = new ParserATNSimulator(this, TableauExpressionParser._ATN, TableauExpressionParser.DecisionsToDFA, new PredictionContextCache());
    }
    get grammarFileName() { return "TableauExpression.g4"; }
    get literalNames() { return TableauExpressionParser.literalNames; }
    get symbolicNames() { return TableauExpressionParser.symbolicNames; }
    get ruleNames() { return TableauExpressionParser.ruleNames; }
    get serializedATN() { return TableauExpressionParser._serializedATN; }
    createFailedPredicateException(predicate, message) {
        return new FailedPredicateException(this, predicate, message);
    }
    // @RuleVersion(0)
    expressionEOF() {
        let localctx = new ExpressionEOFContext(this, this._ctx, this.state);
        this.enterRule(localctx, 0, TableauExpressionParser.RULE_expressionEOF);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 144;
                this.expression();
                this.state = 145;
                this.match(TableauExpressionParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    expression() {
        let localctx = new ExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 2, TableauExpressionParser.RULE_expression);
        try {
            this.state = 150;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 0, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 147;
                        this.lodExpression(0);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 148;
                        this.analyticsExpression(0);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 149;
                        this.scalarExpression(0);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodExpression(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new LodExpressionContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 4;
        this.enterRecursionRule(localctx, 4, TableauExpressionParser.RULE_lodExpression, _p);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 164;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 1, this._ctx)) {
                    case 1:
                        {
                            this.state = 153;
                            this.lodStatement();
                        }
                        break;
                    case 2:
                        {
                            this.state = 154;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 155;
                            this.lodExpression(0);
                            this.state = 156;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 3:
                        {
                            this.state = 158;
                            this.lodStatementIncomplete();
                        }
                        break;
                    case 4:
                        {
                            this.state = 159;
                            this.lodStatementUnsupported();
                        }
                        break;
                    case 5:
                        {
                            this.state = 160;
                            this.comment();
                            this.state = 161;
                            this.lodExpression(3);
                        }
                        break;
                    case 6:
                        {
                            this.state = 163;
                            this.lodStatementNestedExpressions();
                        }
                        break;
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 170;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            {
                                localctx = new LodExpressionContext(this, _parentctx, _parentState);
                                this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_lodExpression);
                                this.state = 166;
                                if (!(this.precpred(this._ctx, 2))) {
                                    throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
                                }
                                this.state = 167;
                                this.comment();
                            }
                        }
                    }
                    this.state = 172;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    scalarExpression(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new ScalarExpressionContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 6;
        this.enterRecursionRule(localctx, 6, TableauExpressionParser.RULE_scalarExpression, _p);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 196;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 3, this._ctx)) {
                    case 1:
                        {
                            localctx = new CommentExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 174;
                            this.comment();
                            this.state = 175;
                            this.scalarExpression(22);
                        }
                        break;
                    case 2:
                        {
                            localctx = new GroupingExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 177;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 178;
                            this.scalarExpression(0);
                            this.state = 179;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 3:
                        {
                            localctx = new NegationExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 181;
                            this.match(TableauExpressionParser.MINUS);
                            this.state = 182;
                            this.scalarExpression(20);
                        }
                        break;
                    case 4:
                        {
                            localctx = new NotExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 183;
                            this.match(TableauExpressionParser.NOT);
                            this.state = 184;
                            this.scalarExpression(15);
                        }
                        break;
                    case 5:
                        {
                            localctx = new IfExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 185;
                            this.ifStatement();
                        }
                        break;
                    case 6:
                        {
                            localctx = new IfExpressionIncompleteContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 186;
                            this.ifStatementIncomplete();
                        }
                        break;
                    case 7:
                        {
                            localctx = new CaseExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 187;
                            this.caseStatement();
                        }
                        break;
                    case 8:
                        {
                            localctx = new CaseExpressionIncompleteContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 188;
                            this.caseStatementIncomplete();
                        }
                        break;
                    case 9:
                        {
                            localctx = new FieldExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 189;
                            this.fieldReference();
                        }
                        break;
                    case 10:
                        {
                            localctx = new FieldExpressionIncompleteContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 190;
                            this.fieldReferenceIncomplete();
                        }
                        break;
                    case 11:
                        {
                            localctx = new FunctionExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 191;
                            this.functionCall();
                        }
                        break;
                    case 12:
                        {
                            localctx = new FunctionExpressionIncompleteContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 192;
                            this.functionCallIncomplete();
                        }
                        break;
                    case 13:
                        {
                            localctx = new LiteralExpressionContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 193;
                            this.literal();
                        }
                        break;
                    case 14:
                        {
                            localctx = new LiteralExpressionIncompleteContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 194;
                            this.literalIncomplete();
                        }
                        break;
                    case 15:
                        {
                            localctx = new LodStatementNotTopLevelContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 195;
                            this.lodExpression(0);
                        }
                        break;
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 223;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 5, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            this.state = 221;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 4, this._ctx)) {
                                case 1:
                                    {
                                        localctx = new ExponentExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 198;
                                        if (!(this.precpred(this._ctx, 19))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 19)");
                                        }
                                        this.state = 199;
                                        this.match(TableauExpressionParser.EXPONENT);
                                        this.state = 200;
                                        this.scalarExpression(20);
                                    }
                                    break;
                                case 2:
                                    {
                                        localctx = new MultDivExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 201;
                                        if (!(this.precpred(this._ctx, 18))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 18)");
                                        }
                                        this.state = 202;
                                        this.multDivOps();
                                        this.state = 203;
                                        this.scalarExpression(19);
                                    }
                                    break;
                                case 3:
                                    {
                                        localctx = new AddSubExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 205;
                                        if (!(this.precpred(this._ctx, 17))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 17)");
                                        }
                                        this.state = 206;
                                        this.addSubOps();
                                        this.state = 207;
                                        this.scalarExpression(18);
                                    }
                                    break;
                                case 4:
                                    {
                                        localctx = new ComparisonExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 209;
                                        if (!(this.precpred(this._ctx, 16))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 16)");
                                        }
                                        this.state = 210;
                                        this.comparisonOps();
                                        this.state = 211;
                                        this.scalarExpression(17);
                                    }
                                    break;
                                case 5:
                                    {
                                        localctx = new AndExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 213;
                                        if (!(this.precpred(this._ctx, 14))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 14)");
                                        }
                                        this.state = 214;
                                        this.match(TableauExpressionParser.AND);
                                        this.state = 215;
                                        this.scalarExpression(15);
                                    }
                                    break;
                                case 6:
                                    {
                                        localctx = new OrExpressionContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 216;
                                        if (!(this.precpred(this._ctx, 13))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 13)");
                                        }
                                        this.state = 217;
                                        this.match(TableauExpressionParser.OR);
                                        this.state = 218;
                                        this.scalarExpression(14);
                                    }
                                    break;
                                case 7:
                                    {
                                        localctx = new ExpressionCommentContext(this, new ScalarExpressionContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_scalarExpression);
                                        this.state = 219;
                                        if (!(this.precpred(this._ctx, 2))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
                                        }
                                        this.state = 220;
                                        this.comment();
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 225;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 5, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    validAnalyticsExpression() {
        let localctx = new ValidAnalyticsExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 8, TableauExpressionParser.RULE_validAnalyticsExpression);
        try {
            this.state = 228;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 6, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 226;
                        this.orderbyExpression();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 227;
                        this.partitionExpression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    multipleValidAnalyticsExpressions(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new MultipleValidAnalyticsExpressionsContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 10;
        this.enterRecursionRule(localctx, 10, TableauExpressionParser.RULE_multipleValidAnalyticsExpressions, _p);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 275;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 7, this._ctx)) {
                    case 1:
                        {
                            localctx = new AddSubExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 231;
                            this.validAnalyticsExpression();
                            this.state = 232;
                            this.addSubOps();
                            this.state = 233;
                            this.validAnalyticsExpression();
                        }
                        break;
                    case 2:
                        {
                            localctx = new MultDivExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 235;
                            this.validAnalyticsExpression();
                            this.state = 236;
                            this.multDivOps();
                            this.state = 237;
                            this.validAnalyticsExpression();
                        }
                        break;
                    case 3:
                        {
                            localctx = new AddSubExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 239;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 240;
                            this.validAnalyticsExpression();
                            this.state = 241;
                            this.addSubOps();
                            this.state = 242;
                            this.validAnalyticsExpression();
                            this.state = 243;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 4:
                        {
                            localctx = new MultDivExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 245;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 246;
                            this.validAnalyticsExpression();
                            this.state = 247;
                            this.multDivOps();
                            this.state = 248;
                            this.validAnalyticsExpression();
                            this.state = 249;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 5:
                        {
                            localctx = new AddSubExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 251;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 252;
                            this.multipleValidAnalyticsExpressions(0);
                            this.state = 253;
                            this.addSubOps();
                            this.state = 254;
                            this.validAnalyticsExpression();
                            this.state = 255;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 6:
                        {
                            localctx = new MultDivExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 257;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 258;
                            this.multipleValidAnalyticsExpressions(0);
                            this.state = 259;
                            this.multDivOps();
                            this.state = 260;
                            this.validAnalyticsExpression();
                            this.state = 261;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 7:
                        {
                            localctx = new MultDivExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 263;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 264;
                            this.multipleValidAnalyticsExpressions(0);
                            this.state = 265;
                            this.multDivOps();
                            this.state = 266;
                            this.floatLiteral();
                            this.state = 267;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 8:
                        {
                            localctx = new MultDivExpressionAnalyticContext(this, localctx);
                            this._ctx = localctx;
                            _prevctx = localctx;
                            this.state = 269;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 270;
                            this.multipleValidAnalyticsExpressions(0);
                            this.state = 271;
                            this.multDivOps();
                            this.state = 272;
                            this.integerLiteral();
                            this.state = 273;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 295;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            this.state = 293;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 8, this._ctx)) {
                                case 1:
                                    {
                                        localctx = new AddSubExpressionAnalyticContext(this, new MultipleValidAnalyticsExpressionsContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_multipleValidAnalyticsExpressions);
                                        this.state = 277;
                                        if (!(this.precpred(this._ctx, 10))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 10)");
                                        }
                                        this.state = 278;
                                        this.addSubOps();
                                        this.state = 279;
                                        this.validAnalyticsExpression();
                                    }
                                    break;
                                case 2:
                                    {
                                        localctx = new MultDivExpressionAnalyticContext(this, new MultipleValidAnalyticsExpressionsContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_multipleValidAnalyticsExpressions);
                                        this.state = 281;
                                        if (!(this.precpred(this._ctx, 9))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 9)");
                                        }
                                        this.state = 282;
                                        this.multDivOps();
                                        this.state = 283;
                                        this.validAnalyticsExpression();
                                    }
                                    break;
                                case 3:
                                    {
                                        localctx = new MultDivExpressionAnalyticContext(this, new MultipleValidAnalyticsExpressionsContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_multipleValidAnalyticsExpressions);
                                        this.state = 285;
                                        if (!(this.precpred(this._ctx, 8))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 8)");
                                        }
                                        this.state = 286;
                                        this.multDivOps();
                                        this.state = 287;
                                        this.floatLiteral();
                                    }
                                    break;
                                case 4:
                                    {
                                        localctx = new MultDivExpressionAnalyticContext(this, new MultipleValidAnalyticsExpressionsContext(this, _parentctx, _parentState));
                                        this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_multipleValidAnalyticsExpressions);
                                        this.state = 289;
                                        if (!(this.precpred(this._ctx, 7))) {
                                            throw this.createFailedPredicateException("this.precpred(this._ctx, 7)");
                                        }
                                        this.state = 290;
                                        this.multDivOps();
                                        this.state = 291;
                                        this.integerLiteral();
                                    }
                                    break;
                            }
                        }
                    }
                    this.state = 297;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 9, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    analyticsExpression(_p) {
        if (_p === undefined) {
            _p = 0;
        }
        let _parentctx = this._ctx;
        let _parentState = this.state;
        let localctx = new AnalyticsExpressionContext(this, this._ctx, _parentState);
        let _prevctx = localctx;
        let _startState = 12;
        this.enterRecursionRule(localctx, 12, TableauExpressionParser.RULE_analyticsExpression, _p);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 314;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 10, this._ctx)) {
                    case 1:
                        {
                            this.state = 299;
                            this.validAnalyticsExpression();
                        }
                        break;
                    case 2:
                        {
                            this.state = 300;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 301;
                            this.analyticsExpression(0);
                            this.state = 302;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                    case 3:
                        {
                            this.state = 304;
                            this.orderbyExpressionIncomplete();
                        }
                        break;
                    case 4:
                        {
                            this.state = 305;
                            this.partitionExpressionIncomplete();
                        }
                        break;
                    case 5:
                        {
                            this.state = 306;
                            this.comment();
                            this.state = 307;
                            this.analyticsExpression(4);
                        }
                        break;
                    case 6:
                        {
                            this.state = 309;
                            this.multipleValidAnalyticsExpressions(0);
                        }
                        break;
                    case 7:
                        {
                            this.state = 310;
                            this.match(TableauExpressionParser.LPAREN);
                            this.state = 311;
                            this.multipleValidAnalyticsExpressions(0);
                            this.state = 312;
                            this.match(TableauExpressionParser.RPAREN);
                        }
                        break;
                }
                this._ctx.stop = this._input.LT(-1);
                this.state = 320;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 11, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        if (this._parseListeners != null) {
                            this.triggerExitRuleEvent();
                        }
                        _prevctx = localctx;
                        {
                            {
                                localctx = new AnalyticsExpressionContext(this, _parentctx, _parentState);
                                this.pushNewRecursionContext(localctx, _startState, TableauExpressionParser.RULE_analyticsExpression);
                                this.state = 316;
                                if (!(this.precpred(this._ctx, 3))) {
                                    throw this.createFailedPredicateException("this.precpred(this._ctx, 3)");
                                }
                                this.state = 317;
                                this.comment();
                            }
                        }
                    }
                    this.state = 322;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 11, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.unrollRecursionContexts(_parentctx);
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyDirection() {
        let localctx = new OrderbyDirectionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 14, TableauExpressionParser.RULE_orderbyDirection);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 323;
                _la = this._input.LA(1);
                if (!(_la === 14 || _la === 15)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyColumn() {
        let localctx = new OrderbyColumnContext(this, this._ctx, this.state);
        this.enterRule(localctx, 16, TableauExpressionParser.RULE_orderbyColumn);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 325;
                this.multiRowFieldReference();
                this.state = 327;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 12, this._ctx)) {
                    case 1:
                        {
                            this.state = 326;
                            this.orderbyDirection();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyColumns() {
        let localctx = new OrderbyColumnsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 18, TableauExpressionParser.RULE_orderbyColumns);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 329;
                this.orderbyColumn();
                this.state = 334;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 13, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 330;
                                this.match(TableauExpressionParser.COMMA);
                                this.state = 331;
                                this.orderbyColumn();
                            }
                        }
                    }
                    this.state = 336;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 13, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyAnalyticsFunction() {
        let localctx = new OrderbyAnalyticsFunctionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 20, TableauExpressionParser.RULE_orderbyAnalyticsFunction);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 337;
                this.multiRowFunctionCall();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyExpression() {
        let localctx = new OrderbyExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 22, TableauExpressionParser.RULE_orderbyExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 339;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 340;
                this.match(TableauExpressionParser.ORDERBY);
                this.state = 341;
                this.orderbyColumns();
                this.state = 342;
                this.match(TableauExpressionParser.COLON);
                this.state = 343;
                this.orderbyAnalyticsFunction();
                this.state = 344;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    orderbyExpressionIncomplete() {
        let localctx = new OrderbyExpressionIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 24, TableauExpressionParser.RULE_orderbyExpressionIncomplete);
        try {
            this.state = 392;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 24, this._ctx)) {
                case 1:
                    localctx = new OrderbyMissingStartBracketContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 346;
                        this.match(TableauExpressionParser.ORDERBY);
                        this.state = 348;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 14, this._ctx)) {
                            case 1:
                                {
                                    this.state = 347;
                                    this.orderbyColumns();
                                }
                                break;
                        }
                        this.state = 351;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 15, this._ctx)) {
                            case 1:
                                {
                                    this.state = 350;
                                    this.match(TableauExpressionParser.COLON);
                                }
                                break;
                        }
                        this.state = 354;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 16, this._ctx)) {
                            case 1:
                                {
                                    this.state = 353;
                                    this.orderbyAnalyticsFunction();
                                }
                                break;
                        }
                        this.state = 357;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 17, this._ctx)) {
                            case 1:
                                {
                                    this.state = 356;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 2:
                    localctx = new OrderbyMissingOrderContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 359;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 360;
                        this.match(TableauExpressionParser.ORDERBY);
                        this.state = 362;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 18, this._ctx)) {
                            case 1:
                                {
                                    this.state = 361;
                                    this.match(TableauExpressionParser.COLON);
                                }
                                break;
                        }
                        this.state = 365;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 19, this._ctx)) {
                            case 1:
                                {
                                    this.state = 364;
                                    this.orderbyAnalyticsFunction();
                                }
                                break;
                        }
                        this.state = 368;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 20, this._ctx)) {
                            case 1:
                                {
                                    this.state = 367;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 3:
                    localctx = new OrderbyMissingColonContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 370;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 371;
                        this.match(TableauExpressionParser.ORDERBY);
                        this.state = 372;
                        this.orderbyColumns();
                        this.state = 374;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 21, this._ctx)) {
                            case 1:
                                {
                                    this.state = 373;
                                    this.orderbyAnalyticsFunction();
                                }
                                break;
                        }
                        this.state = 377;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 22, this._ctx)) {
                            case 1:
                                {
                                    this.state = 376;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 4:
                    localctx = new OrderbyMissingFunctionContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 379;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 380;
                        this.match(TableauExpressionParser.ORDERBY);
                        this.state = 381;
                        this.orderbyColumns();
                        this.state = 382;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 384;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 23, this._ctx)) {
                            case 1:
                                {
                                    this.state = 383;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 5:
                    localctx = new OrderbyMissingEndBracketContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 386;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 387;
                        this.match(TableauExpressionParser.ORDERBY);
                        this.state = 388;
                        this.orderbyColumns();
                        this.state = 389;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 390;
                        this.orderbyAnalyticsFunction();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    partitionByColumn() {
        let localctx = new PartitionByColumnContext(this, this._ctx, this.state);
        this.enterRule(localctx, 26, TableauExpressionParser.RULE_partitionByColumn);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 394;
                this.multiRowFieldReference();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    partitionByColumns() {
        let localctx = new PartitionByColumnsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 28, TableauExpressionParser.RULE_partitionByColumns);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 396;
                this.partitionByColumn();
                this.state = 401;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 25, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 397;
                                this.match(TableauExpressionParser.COMMA);
                                this.state = 398;
                                this.partitionByColumns();
                            }
                        }
                    }
                    this.state = 403;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 25, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    partitionExpression() {
        let localctx = new PartitionExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 30, TableauExpressionParser.RULE_partitionExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 404;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 405;
                this.match(TableauExpressionParser.PARTITION);
                this.state = 406;
                this.partitionByColumns();
                this.state = 407;
                this.match(TableauExpressionParser.COLON);
                this.state = 408;
                this.orderbyExpression();
                this.state = 409;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    partitionExpressionIncomplete() {
        let localctx = new PartitionExpressionIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 32, TableauExpressionParser.RULE_partitionExpressionIncomplete);
        try {
            this.state = 465;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 37, this._ctx)) {
                case 1:
                    localctx = new PartitionMissingStartBracketContext(this, localctx);
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 411;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 413;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 26, this._ctx)) {
                            case 1:
                                {
                                    this.state = 412;
                                    this.partitionByColumns();
                                }
                                break;
                        }
                        this.state = 416;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 27, this._ctx)) {
                            case 1:
                                {
                                    this.state = 415;
                                    this.match(TableauExpressionParser.COLON);
                                }
                                break;
                        }
                        this.state = 419;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 28, this._ctx)) {
                            case 1:
                                {
                                    this.state = 418;
                                    this.orderbyExpression();
                                }
                                break;
                        }
                        this.state = 422;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 29, this._ctx)) {
                            case 1:
                                {
                                    this.state = 421;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 2:
                    localctx = new PartitionMissingPartitionsContext(this, localctx);
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 424;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 425;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 427;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 30, this._ctx)) {
                            case 1:
                                {
                                    this.state = 426;
                                    this.match(TableauExpressionParser.COLON);
                                }
                                break;
                        }
                        this.state = 430;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 31, this._ctx)) {
                            case 1:
                                {
                                    this.state = 429;
                                    this.orderbyExpression();
                                }
                                break;
                        }
                        this.state = 433;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 32, this._ctx)) {
                            case 1:
                                {
                                    this.state = 432;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 3:
                    localctx = new PartitionMissingColonContext(this, localctx);
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 435;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 436;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 437;
                        this.partitionByColumns();
                        this.state = 439;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 33, this._ctx)) {
                            case 1:
                                {
                                    this.state = 438;
                                    this.orderbyExpression();
                                }
                                break;
                        }
                        this.state = 442;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 34, this._ctx)) {
                            case 1:
                                {
                                    this.state = 441;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 4:
                    localctx = new PartitionMissingOrderbyContext(this, localctx);
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 444;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 445;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 446;
                        this.partitionByColumns();
                        this.state = 447;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 449;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 35, this._ctx)) {
                            case 1:
                                {
                                    this.state = 448;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 5:
                    localctx = new PartitionInvalidOrderbyContext(this, localctx);
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 451;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 452;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 453;
                        this.partitionByColumns();
                        this.state = 454;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 455;
                        this.orderbyExpressionIncomplete();
                        this.state = 457;
                        this._errHandler.sync(this);
                        switch (this._interp.adaptivePredict(this._input, 36, this._ctx)) {
                            case 1:
                                {
                                    this.state = 456;
                                    this.match(TableauExpressionParser.RCBRACK);
                                }
                                break;
                        }
                    }
                    break;
                case 6:
                    localctx = new PartitionMissingEndBracketContext(this, localctx);
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 459;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 460;
                        this.match(TableauExpressionParser.PARTITION);
                        this.state = 461;
                        this.partitionByColumns();
                        this.state = 462;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 463;
                        this.orderbyExpression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodGroupBy() {
        let localctx = new LodGroupByContext(this, this._ctx, this.state);
        this.enterRule(localctx, 34, TableauExpressionParser.RULE_lodGroupBy);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 467;
                this.multiRowFieldReference();
                this.state = 472;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 38, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 468;
                                this.match(TableauExpressionParser.COMMA);
                                this.state = 469;
                                this.lodGroupBy();
                            }
                        }
                    }
                    this.state = 474;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 38, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatement() {
        let localctx = new LodStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 36, TableauExpressionParser.RULE_lodStatement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 475;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 476;
                this.match(TableauExpressionParser.FIXED);
                this.state = 478;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (((((_la - 23)) & ~0x1F) === 0 && ((1 << (_la - 23)) & 32789) !== 0)) {
                    {
                        this.state = 477;
                        this.lodGroupBy();
                    }
                }
                this.state = 480;
                this.match(TableauExpressionParser.COLON);
                this.state = 481;
                this.multiRowFunctionCall();
                this.state = 482;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementNestedExpressions() {
        let localctx = new LodStatementNestedExpressionsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 38, TableauExpressionParser.RULE_lodStatementNestedExpressions);
        let _la;
        try {
            this.state = 507;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 41, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 484;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 485;
                        this.match(TableauExpressionParser.FIXED);
                        this.state = 486;
                        this.expression();
                        this.state = 487;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 488;
                        this.functionCall();
                        this.state = 489;
                        this.match(TableauExpressionParser.RCBRACK);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 491;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 492;
                        this.match(TableauExpressionParser.FIXED);
                        this.state = 494;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (((((_la - 23)) & ~0x1F) === 0 && ((1 << (_la - 23)) & 32789) !== 0)) {
                            {
                                this.state = 493;
                                this.lodGroupBy();
                            }
                        }
                        this.state = 496;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 497;
                        this.expression();
                        this.state = 498;
                        this.match(TableauExpressionParser.RCBRACK);
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 500;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 501;
                        this.match(TableauExpressionParser.FIXED);
                        this.state = 502;
                        this.expression();
                        this.state = 503;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 504;
                        this.expression();
                        this.state = 505;
                        this.match(TableauExpressionParser.RCBRACK);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementIncomplete() {
        let localctx = new LodStatementIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 40, TableauExpressionParser.RULE_lodStatementIncomplete);
        try {
            this.state = 514;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 42, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 509;
                        this.lodStatementMissingBrackets();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 510;
                        this.lodStatementMissingLeftBracket();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 511;
                        this.lodStatementMissingRightBracket();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 512;
                        this.lodStatementMissingFixed();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 513;
                        this.lodStatementMissingColon();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementMissingBrackets() {
        let localctx = new LodStatementMissingBracketsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 42, TableauExpressionParser.RULE_lodStatementMissingBrackets);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 516;
                this.match(TableauExpressionParser.FIXED);
                this.state = 525;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 176160768) !== 0)) {
                    {
                        this.state = 517;
                        this.fieldReference();
                        this.state = 522;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 40) {
                            {
                                {
                                    this.state = 518;
                                    this.match(TableauExpressionParser.COMMA);
                                    this.state = 519;
                                    this.fieldReference();
                                }
                            }
                            this.state = 524;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 527;
                this.match(TableauExpressionParser.COLON);
                this.state = 528;
                this.functionCall();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementMissingLeftBracket() {
        let localctx = new LodStatementMissingLeftBracketContext(this, this._ctx, this.state);
        this.enterRule(localctx, 44, TableauExpressionParser.RULE_lodStatementMissingLeftBracket);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 530;
                this.match(TableauExpressionParser.FIXED);
                this.state = 539;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 176160768) !== 0)) {
                    {
                        this.state = 531;
                        this.fieldReference();
                        this.state = 536;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 40) {
                            {
                                {
                                    this.state = 532;
                                    this.match(TableauExpressionParser.COMMA);
                                    this.state = 533;
                                    this.fieldReference();
                                }
                            }
                            this.state = 538;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 541;
                this.match(TableauExpressionParser.COLON);
                this.state = 542;
                this.functionCall();
                this.state = 543;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementMissingRightBracket() {
        let localctx = new LodStatementMissingRightBracketContext(this, this._ctx, this.state);
        this.enterRule(localctx, 46, TableauExpressionParser.RULE_lodStatementMissingRightBracket);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 545;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 546;
                this.match(TableauExpressionParser.FIXED);
                this.state = 555;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 176160768) !== 0)) {
                    {
                        this.state = 547;
                        this.fieldReference();
                        this.state = 552;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 40) {
                            {
                                {
                                    this.state = 548;
                                    this.match(TableauExpressionParser.COMMA);
                                    this.state = 549;
                                    this.fieldReference();
                                }
                            }
                            this.state = 554;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 557;
                this.match(TableauExpressionParser.COLON);
                this.state = 558;
                this.functionCall();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementMissingFixed() {
        let localctx = new LodStatementMissingFixedContext(this, this._ctx, this.state);
        this.enterRule(localctx, 48, TableauExpressionParser.RULE_lodStatementMissingFixed);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 560;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 569;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 176160768) !== 0)) {
                    {
                        this.state = 561;
                        this.fieldReference();
                        this.state = 566;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while (_la === 40) {
                            {
                                {
                                    this.state = 562;
                                    this.match(TableauExpressionParser.COMMA);
                                    this.state = 563;
                                    this.fieldReference();
                                }
                            }
                            this.state = 568;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                    }
                }
                this.state = 571;
                this.match(TableauExpressionParser.COLON);
                this.state = 572;
                this.functionCall();
                this.state = 573;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementMissingColon() {
        let localctx = new LodStatementMissingColonContext(this, this._ctx, this.state);
        this.enterRule(localctx, 50, TableauExpressionParser.RULE_lodStatementMissingColon);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 575;
                this.match(TableauExpressionParser.LCBRACK);
                this.state = 576;
                this.match(TableauExpressionParser.FIXED);
                this.state = 585;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 52, this._ctx)) {
                    case 1:
                        {
                            this.state = 577;
                            this.fieldReference();
                            this.state = 582;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                            while (_la === 40) {
                                {
                                    {
                                        this.state = 578;
                                        this.match(TableauExpressionParser.COMMA);
                                        this.state = 579;
                                        this.fieldReference();
                                    }
                                }
                                this.state = 584;
                                this._errHandler.sync(this);
                                _la = this._input.LA(1);
                            }
                        }
                        break;
                }
                this.state = 587;
                this.functionCall();
                this.state = 588;
                this.match(TableauExpressionParser.RCBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    lodStatementUnsupported() {
        let localctx = new LodStatementUnsupportedContext(this, this._ctx, this.state);
        this.enterRule(localctx, 52, TableauExpressionParser.RULE_lodStatementUnsupported);
        let _la;
        try {
            this.state = 608;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 55, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 590;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 591;
                        localctx._lodFunction = this.match(TableauExpressionParser.INCLUDE);
                        this.state = 593;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (((((_la - 23)) & ~0x1F) === 0 && ((1 << (_la - 23)) & 32789) !== 0)) {
                            {
                                this.state = 592;
                                this.lodGroupBy();
                            }
                        }
                        this.state = 595;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 596;
                        this.functionCall();
                        this.state = 597;
                        this.match(TableauExpressionParser.RCBRACK);
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 599;
                        this.match(TableauExpressionParser.LCBRACK);
                        this.state = 600;
                        localctx._lodFunction = this.match(TableauExpressionParser.EXCLUDE);
                        this.state = 602;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        if (((((_la - 23)) & ~0x1F) === 0 && ((1 << (_la - 23)) & 32789) !== 0)) {
                            {
                                this.state = 601;
                                this.lodGroupBy();
                            }
                        }
                        this.state = 604;
                        this.match(TableauExpressionParser.COLON);
                        this.state = 605;
                        this.functionCall();
                        this.state = 606;
                        this.match(TableauExpressionParser.RCBRACK);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    comment() {
        let localctx = new CommentContext(this, this._ctx, this.state);
        this.enterRule(localctx, 54, TableauExpressionParser.RULE_comment);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 610;
                this.match(TableauExpressionParser.COMMENT);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    multDivOps() {
        let localctx = new MultDivOpsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 56, TableauExpressionParser.RULE_multDivOps);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 612;
                _la = this._input.LA(1);
                if (!(((((_la - 44)) & ~0x1F) === 0 && ((1 << (_la - 44)) & 7) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    addSubOps() {
        let localctx = new AddSubOpsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 58, TableauExpressionParser.RULE_addSubOps);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 614;
                _la = this._input.LA(1);
                if (!(_la === 42 || _la === 43)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    comparisonOps() {
        let localctx = new ComparisonOpsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 60, TableauExpressionParser.RULE_comparisonOps);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 616;
                _la = this._input.LA(1);
                if (!(((((_la - 48)) & ~0x1F) === 0 && ((1 << (_la - 48)) & 63) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatement() {
        let localctx = new IfStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 62, TableauExpressionParser.RULE_ifStatement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 618;
                this.match(TableauExpressionParser.IF);
                this.state = 619;
                this.scalarExpression(0);
                this.state = 620;
                this.match(TableauExpressionParser.THEN);
                this.state = 621;
                this.scalarExpression(0);
                this.state = 625;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 4) {
                    {
                        {
                            this.state = 622;
                            this.elseIfStatement();
                        }
                    }
                    this.state = 627;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 629;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 3) {
                    {
                        this.state = 628;
                        this.elseStatement();
                    }
                }
                this.state = 631;
                this.match(TableauExpressionParser.END);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    elseIfStatement() {
        let localctx = new ElseIfStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 64, TableauExpressionParser.RULE_elseIfStatement);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 633;
                this.match(TableauExpressionParser.ELSEIF);
                this.state = 634;
                this.scalarExpression(0);
                this.state = 635;
                this.match(TableauExpressionParser.THEN);
                this.state = 636;
                this.scalarExpression(0);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    elseStatement() {
        let localctx = new ElseStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 66, TableauExpressionParser.RULE_elseStatement);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 638;
                this.match(TableauExpressionParser.ELSE);
                this.state = 639;
                this.scalarExpression(0);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementIncomplete() {
        let localctx = new IfStatementIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 68, TableauExpressionParser.RULE_ifStatementIncomplete);
        try {
            this.state = 651;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 58, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 641;
                        this.ifStatementMissingCondition();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 642;
                        this.ifStatementMissingThen();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 643;
                        this.ifStatementMissingThenExpression();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 644;
                        this.ifStatementMissingEnd();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 645;
                        this.ifStatementMissingElse();
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 646;
                        this.ifStatementMissingElseExpression();
                    }
                    break;
                case 7:
                    this.enterOuterAlt(localctx, 7);
                    {
                        this.state = 647;
                        this.ifStatementMissingElseIf();
                    }
                    break;
                case 8:
                    this.enterOuterAlt(localctx, 8);
                    {
                        this.state = 648;
                        this.ifStatementMissingElseIfCondition();
                    }
                    break;
                case 9:
                    this.enterOuterAlt(localctx, 9);
                    {
                        this.state = 649;
                        this.ifStatementMissingElseIfThen();
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 10);
                    {
                        this.state = 650;
                        this.ifStatementMissingElseIfThenExpression();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingCondition() {
        let localctx = new IfStatementMissingConditionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 70, TableauExpressionParser.RULE_ifStatementMissingCondition);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 653;
                this.match(TableauExpressionParser.IF);
                this.state = 655;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 59, this._ctx)) {
                    case 1:
                        {
                            this.state = 654;
                            this.match(TableauExpressionParser.THEN);
                        }
                        break;
                }
                this.state = 658;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 60, this._ctx)) {
                    case 1:
                        {
                            this.state = 657;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 663;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 61, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 660;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 665;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 61, this._ctx);
                }
                this.state = 667;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 62, this._ctx)) {
                    case 1:
                        {
                            this.state = 666;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 670;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 63, this._ctx)) {
                    case 1:
                        {
                            this.state = 669;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingThen() {
        let localctx = new IfStatementMissingThenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 72, TableauExpressionParser.RULE_ifStatementMissingThen);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 672;
                this.match(TableauExpressionParser.IF);
                this.state = 673;
                this.scalarExpression(0);
                this.state = 675;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 64, this._ctx)) {
                    case 1:
                        {
                            this.state = 674;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 680;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 65, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 677;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 682;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 65, this._ctx);
                }
                this.state = 684;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 66, this._ctx)) {
                    case 1:
                        {
                            this.state = 683;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 687;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 67, this._ctx)) {
                    case 1:
                        {
                            this.state = 686;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingThenExpression() {
        let localctx = new IfStatementMissingThenExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 74, TableauExpressionParser.RULE_ifStatementMissingThenExpression);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 689;
                this.match(TableauExpressionParser.IF);
                this.state = 690;
                this.scalarExpression(0);
                this.state = 691;
                this.match(TableauExpressionParser.THEN);
                this.state = 695;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 68, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 692;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 697;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 68, this._ctx);
                }
                this.state = 699;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 69, this._ctx)) {
                    case 1:
                        {
                            this.state = 698;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 702;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 70, this._ctx)) {
                    case 1:
                        {
                            this.state = 701;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElse() {
        let localctx = new IfStatementMissingElseContext(this, this._ctx, this.state);
        this.enterRule(localctx, 76, TableauExpressionParser.RULE_ifStatementMissingElse);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 704;
                this.match(TableauExpressionParser.IF);
                this.state = 705;
                this.scalarExpression(0);
                this.state = 706;
                this.match(TableauExpressionParser.THEN);
                this.state = 707;
                this.scalarExpression(0);
                this.state = 711;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 71, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 708;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 713;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 71, this._ctx);
                }
                this.state = 715;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 72, this._ctx)) {
                    case 1:
                        {
                            this.state = 714;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 718;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 73, this._ctx)) {
                    case 1:
                        {
                            this.state = 717;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElseExpression() {
        let localctx = new IfStatementMissingElseExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 78, TableauExpressionParser.RULE_ifStatementMissingElseExpression);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 720;
                this.match(TableauExpressionParser.IF);
                this.state = 721;
                this.scalarExpression(0);
                this.state = 722;
                this.match(TableauExpressionParser.THEN);
                this.state = 723;
                this.scalarExpression(0);
                this.state = 727;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 4) {
                    {
                        {
                            this.state = 724;
                            this.elseIfStatement();
                        }
                    }
                    this.state = 729;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 730;
                this.match(TableauExpressionParser.ELSE);
                this.state = 732;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 75, this._ctx)) {
                    case 1:
                        {
                            this.state = 731;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingEnd() {
        let localctx = new IfStatementMissingEndContext(this, this._ctx, this.state);
        this.enterRule(localctx, 80, TableauExpressionParser.RULE_ifStatementMissingEnd);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 734;
                this.match(TableauExpressionParser.IF);
                this.state = 735;
                this.scalarExpression(0);
                this.state = 736;
                this.match(TableauExpressionParser.THEN);
                this.state = 737;
                this.scalarExpression(0);
                this.state = 741;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 76, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 738;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 743;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 76, this._ctx);
                }
                this.state = 745;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 77, this._ctx)) {
                    case 1:
                        {
                            this.state = 744;
                            this.elseStatement();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElseIf() {
        let localctx = new IfStatementMissingElseIfContext(this, this._ctx, this.state);
        this.enterRule(localctx, 82, TableauExpressionParser.RULE_ifStatementMissingElseIf);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 747;
                this.match(TableauExpressionParser.IF);
                this.state = 748;
                this.scalarExpression(0);
                this.state = 749;
                this.match(TableauExpressionParser.THEN);
                this.state = 750;
                this.scalarExpression(0);
                this.state = 754;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 78, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 751;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 756;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 78, this._ctx);
                }
                this.state = 758;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 79, this._ctx)) {
                    case 1:
                        {
                            this.state = 757;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 761;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 80, this._ctx)) {
                    case 1:
                        {
                            this.state = 760;
                            this.match(TableauExpressionParser.THEN);
                        }
                        break;
                }
                this.state = 764;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 81, this._ctx)) {
                    case 1:
                        {
                            this.state = 763;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 769;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 82, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 766;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 771;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 82, this._ctx);
                }
                this.state = 773;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 83, this._ctx)) {
                    case 1:
                        {
                            this.state = 772;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 776;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 84, this._ctx)) {
                    case 1:
                        {
                            this.state = 775;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElseIfCondition() {
        let localctx = new IfStatementMissingElseIfConditionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 84, TableauExpressionParser.RULE_ifStatementMissingElseIfCondition);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 778;
                this.match(TableauExpressionParser.IF);
                this.state = 779;
                this.scalarExpression(0);
                this.state = 780;
                this.match(TableauExpressionParser.THEN);
                this.state = 781;
                this.scalarExpression(0);
                this.state = 785;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 85, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 782;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 787;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 85, this._ctx);
                }
                this.state = 788;
                this.match(TableauExpressionParser.ELSEIF);
                this.state = 790;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 86, this._ctx)) {
                    case 1:
                        {
                            this.state = 789;
                            this.match(TableauExpressionParser.THEN);
                        }
                        break;
                }
                this.state = 793;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 87, this._ctx)) {
                    case 1:
                        {
                            this.state = 792;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 798;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 88, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 795;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 800;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 88, this._ctx);
                }
                this.state = 802;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 89, this._ctx)) {
                    case 1:
                        {
                            this.state = 801;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 805;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 90, this._ctx)) {
                    case 1:
                        {
                            this.state = 804;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElseIfThen() {
        let localctx = new IfStatementMissingElseIfThenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 86, TableauExpressionParser.RULE_ifStatementMissingElseIfThen);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 807;
                this.match(TableauExpressionParser.IF);
                this.state = 808;
                this.scalarExpression(0);
                this.state = 809;
                this.match(TableauExpressionParser.THEN);
                this.state = 810;
                this.scalarExpression(0);
                this.state = 814;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 91, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 811;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 816;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 91, this._ctx);
                }
                this.state = 817;
                this.match(TableauExpressionParser.ELSEIF);
                this.state = 818;
                this.scalarExpression(0);
                this.state = 820;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 92, this._ctx)) {
                    case 1:
                        {
                            this.state = 819;
                            this.scalarExpression(0);
                        }
                        break;
                }
                this.state = 825;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 93, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 822;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 827;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 93, this._ctx);
                }
                this.state = 829;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 94, this._ctx)) {
                    case 1:
                        {
                            this.state = 828;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 832;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 95, this._ctx)) {
                    case 1:
                        {
                            this.state = 831;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    ifStatementMissingElseIfThenExpression() {
        let localctx = new IfStatementMissingElseIfThenExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 88, TableauExpressionParser.RULE_ifStatementMissingElseIfThenExpression);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 834;
                this.match(TableauExpressionParser.IF);
                this.state = 835;
                this.scalarExpression(0);
                this.state = 836;
                this.match(TableauExpressionParser.THEN);
                this.state = 837;
                this.scalarExpression(0);
                this.state = 841;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 96, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 838;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 843;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 96, this._ctx);
                }
                this.state = 844;
                this.match(TableauExpressionParser.ELSEIF);
                this.state = 845;
                this.scalarExpression(0);
                this.state = 846;
                this.match(TableauExpressionParser.THEN);
                this.state = 850;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 97, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 847;
                                this.elseIfStatement();
                            }
                        }
                    }
                    this.state = 852;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 97, this._ctx);
                }
                this.state = 854;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 98, this._ctx)) {
                    case 1:
                        {
                            this.state = 853;
                            this.elseStatement();
                        }
                        break;
                }
                this.state = 857;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 99, this._ctx)) {
                    case 1:
                        {
                            this.state = 856;
                            this.match(TableauExpressionParser.END);
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatement() {
        let localctx = new CaseStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 90, TableauExpressionParser.RULE_caseStatement);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 859;
                this.match(TableauExpressionParser.CASE);
                this.state = 860;
                this.scalarExpression(0);
                this.state = 864;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === 7) {
                    {
                        {
                            this.state = 861;
                            this.whenStatement();
                        }
                    }
                    this.state = 866;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 868;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === 3) {
                    {
                        this.state = 867;
                        this.elseStatement();
                    }
                }
                this.state = 870;
                this.match(TableauExpressionParser.END);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    whenStatement() {
        let localctx = new WhenStatementContext(this, this._ctx, this.state);
        this.enterRule(localctx, 92, TableauExpressionParser.RULE_whenStatement);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 872;
                this.match(TableauExpressionParser.WHEN);
                this.state = 873;
                this.scalarExpression(0);
                this.state = 874;
                this.match(TableauExpressionParser.THEN);
                this.state = 875;
                this.scalarExpression(0);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementIncomplete() {
        let localctx = new CaseStatementIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 94, TableauExpressionParser.RULE_caseStatementIncomplete);
        try {
            this.state = 883;
            this._errHandler.sync(this);
            switch (this._interp.adaptivePredict(this._input, 102, this._ctx)) {
                case 1:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 877;
                        this.caseStatementMissingCaseExpression();
                    }
                    break;
                case 2:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 878;
                        this.caseStatementMissingWhen();
                    }
                    break;
                case 3:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 879;
                        this.caseStatementMissingWhenExpression();
                    }
                    break;
                case 4:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 880;
                        this.caseStatementMissingThen();
                    }
                    break;
                case 5:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 881;
                        this.caseStatementMissingThenExpression();
                    }
                    break;
                case 6:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 882;
                        this.caseStatementMissingEnd();
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingCaseExpression() {
        let localctx = new CaseStatementMissingCaseExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 96, TableauExpressionParser.RULE_caseStatementMissingCaseExpression);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 885;
                this.match(TableauExpressionParser.CASE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingWhen() {
        let localctx = new CaseStatementMissingWhenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 98, TableauExpressionParser.RULE_caseStatementMissingWhen);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 887;
                this.match(TableauExpressionParser.CASE);
                this.state = 888;
                this.scalarExpression(0);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingWhenExpression() {
        let localctx = new CaseStatementMissingWhenExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 100, TableauExpressionParser.RULE_caseStatementMissingWhenExpression);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 890;
                this.match(TableauExpressionParser.CASE);
                this.state = 891;
                this.scalarExpression(0);
                this.state = 895;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 103, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 892;
                                this.whenStatement();
                            }
                        }
                    }
                    this.state = 897;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 103, this._ctx);
                }
                this.state = 898;
                this.match(TableauExpressionParser.WHEN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingThen() {
        let localctx = new CaseStatementMissingThenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 102, TableauExpressionParser.RULE_caseStatementMissingThen);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 900;
                this.match(TableauExpressionParser.CASE);
                this.state = 901;
                this.scalarExpression(0);
                this.state = 905;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 104, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 902;
                                this.whenStatement();
                            }
                        }
                    }
                    this.state = 907;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 104, this._ctx);
                }
                this.state = 908;
                this.match(TableauExpressionParser.WHEN);
                this.state = 909;
                this.scalarExpression(0);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingThenExpression() {
        let localctx = new CaseStatementMissingThenExpressionContext(this, this._ctx, this.state);
        this.enterRule(localctx, 104, TableauExpressionParser.RULE_caseStatementMissingThenExpression);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 911;
                this.match(TableauExpressionParser.CASE);
                this.state = 912;
                this.scalarExpression(0);
                this.state = 916;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 105, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 913;
                                this.whenStatement();
                            }
                        }
                    }
                    this.state = 918;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 105, this._ctx);
                }
                this.state = 919;
                this.match(TableauExpressionParser.WHEN);
                this.state = 920;
                this.scalarExpression(0);
                this.state = 921;
                this.match(TableauExpressionParser.THEN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    caseStatementMissingEnd() {
        let localctx = new CaseStatementMissingEndContext(this, this._ctx, this.state);
        this.enterRule(localctx, 106, TableauExpressionParser.RULE_caseStatementMissingEnd);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 923;
                this.match(TableauExpressionParser.CASE);
                this.state = 924;
                this.scalarExpression(0);
                this.state = 928;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 106, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 925;
                                this.whenStatement();
                            }
                        }
                    }
                    this.state = 930;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 106, this._ctx);
                }
                this.state = 932;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 107, this._ctx)) {
                    case 1:
                        {
                            this.state = 931;
                            this.elseStatement();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    multiRowFieldReference() {
        let localctx = new MultiRowFieldReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 108, TableauExpressionParser.RULE_multiRowFieldReference);
        try {
            this.state = 939;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 23:
                case 25:
                case 27:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 934;
                        this.fieldReference();
                    }
                    break;
                case 38:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 935;
                        this.match(TableauExpressionParser.LPAREN);
                        this.state = 936;
                        this.fieldReference();
                        this.state = 937;
                        this.match(TableauExpressionParser.RPAREN);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    multiRowFunctionCall() {
        let localctx = new MultiRowFunctionCallContext(this, this._ctx, this.state);
        this.enterRule(localctx, 110, TableauExpressionParser.RULE_multiRowFunctionCall);
        try {
            this.state = 946;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 23:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 941;
                        this.functionCall();
                    }
                    break;
                case 38:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 942;
                        this.match(TableauExpressionParser.LPAREN);
                        this.state = 943;
                        this.functionCall();
                        this.state = 944;
                        this.match(TableauExpressionParser.RPAREN);
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    fieldReference() {
        let localctx = new FieldReferenceContext(this, this._ctx, this.state);
        this.enterRule(localctx, 112, TableauExpressionParser.RULE_fieldReference);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 948;
                _la = this._input.LA(1);
                if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & 176160768) !== 0))) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    fieldReferenceIncomplete() {
        let localctx = new FieldReferenceIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 114, TableauExpressionParser.RULE_fieldReferenceIncomplete);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 950;
                _la = this._input.LA(1);
                if (!(_la === 26 || _la === 28)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionCall() {
        let localctx = new FunctionCallContext(this, this._ctx, this.state);
        this.enterRule(localctx, 116, TableauExpressionParser.RULE_functionCall);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 952;
                localctx._functionName = this.match(TableauExpressionParser.IDENTIFIER);
                this.state = 953;
                this.match(TableauExpressionParser.LPAREN);
                this.state = 955;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 4274267970) !== 0) || ((((_la - 32)) & ~0x1F) === 0 && ((1 << (_la - 32)) & 2135) !== 0)) {
                    {
                        this.state = 954;
                        this.functionArgs();
                    }
                }
                this.state = 957;
                this.match(TableauExpressionParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionArgs() {
        let localctx = new FunctionArgsContext(this, this._ctx, this.state);
        this.enterRule(localctx, 118, TableauExpressionParser.RULE_functionArgs);
        try {
            let _alt;
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 959;
                this.scalarExpression(0);
                this.state = 964;
                this._errHandler.sync(this);
                _alt = this._interp.adaptivePredict(this._input, 111, this._ctx);
                while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
                    if (_alt === 1) {
                        {
                            {
                                this.state = 960;
                                this.match(TableauExpressionParser.COMMA);
                                this.state = 961;
                                this.scalarExpression(0);
                            }
                        }
                    }
                    this.state = 966;
                    this._errHandler.sync(this);
                    _alt = this._interp.adaptivePredict(this._input, 111, this._ctx);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionCallIncomplete() {
        let localctx = new FunctionCallIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 120, TableauExpressionParser.RULE_functionCallIncomplete);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 967;
                this.functionCallMissingCloseParen();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    functionCallMissingCloseParen() {
        let localctx = new FunctionCallMissingCloseParenContext(this, this._ctx, this.state);
        this.enterRule(localctx, 122, TableauExpressionParser.RULE_functionCallMissingCloseParen);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 969;
                localctx._functionName = this.match(TableauExpressionParser.IDENTIFIER);
                this.state = 970;
                this.match(TableauExpressionParser.LPAREN);
                this.state = 972;
                this._errHandler.sync(this);
                switch (this._interp.adaptivePredict(this._input, 112, this._ctx)) {
                    case 1:
                        {
                            this.state = 971;
                            this.functionArgs();
                        }
                        break;
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    literal() {
        let localctx = new LiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 124, TableauExpressionParser.RULE_literal);
        try {
            this.state = 980;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 31:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 974;
                        this.dateLiteral();
                    }
                    break;
                case 29:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 975;
                        this.stringLiteral();
                    }
                    break;
                case 33:
                    this.enterOuterAlt(localctx, 3);
                    {
                        this.state = 976;
                        this.integerLiteral();
                    }
                    break;
                case 34:
                    this.enterOuterAlt(localctx, 4);
                    {
                        this.state = 977;
                        this.floatLiteral();
                    }
                    break;
                case 8:
                case 9:
                    this.enterOuterAlt(localctx, 5);
                    {
                        this.state = 978;
                        this.booleanLiteral();
                    }
                    break;
                case 10:
                    this.enterOuterAlt(localctx, 6);
                    {
                        this.state = 979;
                        this.nullLiteral();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dateLiteral() {
        let localctx = new DateLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 126, TableauExpressionParser.RULE_dateLiteral);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 982;
                this.match(TableauExpressionParser.DATELITERAL);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringLiteral() {
        let localctx = new StringLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 128, TableauExpressionParser.RULE_stringLiteral);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 984;
                this.match(TableauExpressionParser.STRINGLITERAL);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    integerLiteral() {
        let localctx = new IntegerLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 130, TableauExpressionParser.RULE_integerLiteral);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 986;
                this.match(TableauExpressionParser.INTEGER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    floatLiteral() {
        let localctx = new FloatLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 132, TableauExpressionParser.RULE_floatLiteral);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 988;
                this.match(TableauExpressionParser.FLOAT);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    booleanLiteral() {
        let localctx = new BooleanLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 134, TableauExpressionParser.RULE_booleanLiteral);
        let _la;
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 990;
                _la = this._input.LA(1);
                if (!(_la === 8 || _la === 9)) {
                    this._errHandler.recoverInline(this);
                }
                else {
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    nullLiteral() {
        let localctx = new NullLiteralContext(this, this._ctx, this.state);
        this.enterRule(localctx, 136, TableauExpressionParser.RULE_nullLiteral);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 992;
                this.match(TableauExpressionParser.NULL);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    literalIncomplete() {
        let localctx = new LiteralIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 138, TableauExpressionParser.RULE_literalIncomplete);
        try {
            this.state = 996;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case 32:
                    this.enterOuterAlt(localctx, 1);
                    {
                        this.state = 994;
                        this.dateLiteralIncomplete();
                    }
                    break;
                case 30:
                    this.enterOuterAlt(localctx, 2);
                    {
                        this.state = 995;
                        this.stringLiteralIncomplete();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    dateLiteralIncomplete() {
        let localctx = new DateLiteralIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 140, TableauExpressionParser.RULE_dateLiteralIncomplete);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 998;
                this.match(TableauExpressionParser.DATELITERAL_INCOMPLETE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    // @RuleVersion(0)
    stringLiteralIncomplete() {
        let localctx = new StringLiteralIncompleteContext(this, this._ctx, this.state);
        this.enterRule(localctx, 142, TableauExpressionParser.RULE_stringLiteralIncomplete);
        try {
            this.enterOuterAlt(localctx, 1);
            {
                this.state = 1000;
                this.match(TableauExpressionParser.STRINGLITERAL_INCOMPLETE);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localctx;
    }
    sempred(localctx, ruleIndex, predIndex) {
        switch (ruleIndex) {
            case 2:
                return this.lodExpression_sempred(localctx, predIndex);
            case 3:
                return this.scalarExpression_sempred(localctx, predIndex);
            case 5:
                return this.multipleValidAnalyticsExpressions_sempred(localctx, predIndex);
            case 6:
                return this.analyticsExpression_sempred(localctx, predIndex);
        }
        return true;
    }
    lodExpression_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 0:
                return this.precpred(this._ctx, 2);
        }
        return true;
    }
    scalarExpression_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 1:
                return this.precpred(this._ctx, 19);
            case 2:
                return this.precpred(this._ctx, 18);
            case 3:
                return this.precpred(this._ctx, 17);
            case 4:
                return this.precpred(this._ctx, 16);
            case 5:
                return this.precpred(this._ctx, 14);
            case 6:
                return this.precpred(this._ctx, 13);
            case 7:
                return this.precpred(this._ctx, 2);
        }
        return true;
    }
    multipleValidAnalyticsExpressions_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 8:
                return this.precpred(this._ctx, 10);
            case 9:
                return this.precpred(this._ctx, 9);
            case 10:
                return this.precpred(this._ctx, 8);
            case 11:
                return this.precpred(this._ctx, 7);
        }
        return true;
    }
    analyticsExpression_sempred(localctx, predIndex) {
        switch (predIndex) {
            case 12:
                return this.precpred(this._ctx, 3);
        }
        return true;
    }
    static get _ATN() {
        if (!TableauExpressionParser.__ATN) {
            TableauExpressionParser.__ATN = new ATNDeserializer().deserialize(TableauExpressionParser._serializedATN);
        }
        return TableauExpressionParser.__ATN;
    }
}
TableauExpressionParser.IF = 1;
TableauExpressionParser.THEN = 2;
TableauExpressionParser.ELSE = 3;
TableauExpressionParser.ELSEIF = 4;
TableauExpressionParser.END = 5;
TableauExpressionParser.CASE = 6;
TableauExpressionParser.WHEN = 7;
TableauExpressionParser.TRUE = 8;
TableauExpressionParser.FALSE = 9;
TableauExpressionParser.NULL = 10;
TableauExpressionParser.AND = 11;
TableauExpressionParser.OR = 12;
TableauExpressionParser.NOT = 13;
TableauExpressionParser.ASC = 14;
TableauExpressionParser.DESC = 15;
TableauExpressionParser.ORDERBY = 16;
TableauExpressionParser.PARTITION = 17;
TableauExpressionParser.FIXED = 18;
TableauExpressionParser.INCLUDE = 19;
TableauExpressionParser.EXCLUDE = 20;
TableauExpressionParser.PARAMETERS = 21;
TableauExpressionParser.COMMENT = 22;
TableauExpressionParser.IDENTIFIER = 23;
TableauExpressionParser.PARAMETER = 24;
TableauExpressionParser.PARAMETER_IN_BRACKETS = 25;
TableauExpressionParser.PARAMETER_INCOMPLETE = 26;
TableauExpressionParser.FIELDNAME = 27;
TableauExpressionParser.FIELDNAME_INCOMPLETE = 28;
TableauExpressionParser.STRINGLITERAL = 29;
TableauExpressionParser.STRINGLITERAL_INCOMPLETE = 30;
TableauExpressionParser.DATELITERAL = 31;
TableauExpressionParser.DATELITERAL_INCOMPLETE = 32;
TableauExpressionParser.INTEGER = 33;
TableauExpressionParser.FLOAT = 34;
TableauExpressionParser.RBRACKET = 35;
TableauExpressionParser.LCBRACK = 36;
TableauExpressionParser.RCBRACK = 37;
TableauExpressionParser.LPAREN = 38;
TableauExpressionParser.RPAREN = 39;
TableauExpressionParser.COMMA = 40;
TableauExpressionParser.COLON = 41;
TableauExpressionParser.PLUS = 42;
TableauExpressionParser.MINUS = 43;
TableauExpressionParser.DIVIDE = 44;
TableauExpressionParser.MULTIPLY = 45;
TableauExpressionParser.MOD = 46;
TableauExpressionParser.EXPONENT = 47;
TableauExpressionParser.GT = 48;
TableauExpressionParser.LT = 49;
TableauExpressionParser.GTE = 50;
TableauExpressionParser.LTE = 51;
TableauExpressionParser.EQ = 52;
TableauExpressionParser.NEQ = 53;
TableauExpressionParser.WHITESPACE = 54;
TableauExpressionParser.EOF = Token.EOF;
TableauExpressionParser.RULE_expressionEOF = 0;
TableauExpressionParser.RULE_expression = 1;
TableauExpressionParser.RULE_lodExpression = 2;
TableauExpressionParser.RULE_scalarExpression = 3;
TableauExpressionParser.RULE_validAnalyticsExpression = 4;
TableauExpressionParser.RULE_multipleValidAnalyticsExpressions = 5;
TableauExpressionParser.RULE_analyticsExpression = 6;
TableauExpressionParser.RULE_orderbyDirection = 7;
TableauExpressionParser.RULE_orderbyColumn = 8;
TableauExpressionParser.RULE_orderbyColumns = 9;
TableauExpressionParser.RULE_orderbyAnalyticsFunction = 10;
TableauExpressionParser.RULE_orderbyExpression = 11;
TableauExpressionParser.RULE_orderbyExpressionIncomplete = 12;
TableauExpressionParser.RULE_partitionByColumn = 13;
TableauExpressionParser.RULE_partitionByColumns = 14;
TableauExpressionParser.RULE_partitionExpression = 15;
TableauExpressionParser.RULE_partitionExpressionIncomplete = 16;
TableauExpressionParser.RULE_lodGroupBy = 17;
TableauExpressionParser.RULE_lodStatement = 18;
TableauExpressionParser.RULE_lodStatementNestedExpressions = 19;
TableauExpressionParser.RULE_lodStatementIncomplete = 20;
TableauExpressionParser.RULE_lodStatementMissingBrackets = 21;
TableauExpressionParser.RULE_lodStatementMissingLeftBracket = 22;
TableauExpressionParser.RULE_lodStatementMissingRightBracket = 23;
TableauExpressionParser.RULE_lodStatementMissingFixed = 24;
TableauExpressionParser.RULE_lodStatementMissingColon = 25;
TableauExpressionParser.RULE_lodStatementUnsupported = 26;
TableauExpressionParser.RULE_comment = 27;
TableauExpressionParser.RULE_multDivOps = 28;
TableauExpressionParser.RULE_addSubOps = 29;
TableauExpressionParser.RULE_comparisonOps = 30;
TableauExpressionParser.RULE_ifStatement = 31;
TableauExpressionParser.RULE_elseIfStatement = 32;
TableauExpressionParser.RULE_elseStatement = 33;
TableauExpressionParser.RULE_ifStatementIncomplete = 34;
TableauExpressionParser.RULE_ifStatementMissingCondition = 35;
TableauExpressionParser.RULE_ifStatementMissingThen = 36;
TableauExpressionParser.RULE_ifStatementMissingThenExpression = 37;
TableauExpressionParser.RULE_ifStatementMissingElse = 38;
TableauExpressionParser.RULE_ifStatementMissingElseExpression = 39;
TableauExpressionParser.RULE_ifStatementMissingEnd = 40;
TableauExpressionParser.RULE_ifStatementMissingElseIf = 41;
TableauExpressionParser.RULE_ifStatementMissingElseIfCondition = 42;
TableauExpressionParser.RULE_ifStatementMissingElseIfThen = 43;
TableauExpressionParser.RULE_ifStatementMissingElseIfThenExpression = 44;
TableauExpressionParser.RULE_caseStatement = 45;
TableauExpressionParser.RULE_whenStatement = 46;
TableauExpressionParser.RULE_caseStatementIncomplete = 47;
TableauExpressionParser.RULE_caseStatementMissingCaseExpression = 48;
TableauExpressionParser.RULE_caseStatementMissingWhen = 49;
TableauExpressionParser.RULE_caseStatementMissingWhenExpression = 50;
TableauExpressionParser.RULE_caseStatementMissingThen = 51;
TableauExpressionParser.RULE_caseStatementMissingThenExpression = 52;
TableauExpressionParser.RULE_caseStatementMissingEnd = 53;
TableauExpressionParser.RULE_multiRowFieldReference = 54;
TableauExpressionParser.RULE_multiRowFunctionCall = 55;
TableauExpressionParser.RULE_fieldReference = 56;
TableauExpressionParser.RULE_fieldReferenceIncomplete = 57;
TableauExpressionParser.RULE_functionCall = 58;
TableauExpressionParser.RULE_functionArgs = 59;
TableauExpressionParser.RULE_functionCallIncomplete = 60;
TableauExpressionParser.RULE_functionCallMissingCloseParen = 61;
TableauExpressionParser.RULE_literal = 62;
TableauExpressionParser.RULE_dateLiteral = 63;
TableauExpressionParser.RULE_stringLiteral = 64;
TableauExpressionParser.RULE_integerLiteral = 65;
TableauExpressionParser.RULE_floatLiteral = 66;
TableauExpressionParser.RULE_booleanLiteral = 67;
TableauExpressionParser.RULE_nullLiteral = 68;
TableauExpressionParser.RULE_literalIncomplete = 69;
TableauExpressionParser.RULE_dateLiteralIncomplete = 70;
TableauExpressionParser.RULE_stringLiteralIncomplete = 71;
TableauExpressionParser.literalNames = [null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, null,
    null, "']'",
    "'{'", "'}'",
    "'('", "')'",
    "','", "':'",
    "'+'", "'-'",
    "'/'", "'*'",
    "'%'", "'^'",
    "'>'", "'<'",
    "'>='", "'<='"];
TableauExpressionParser.symbolicNames = [null, "IF",
    "THEN", "ELSE",
    "ELSEIF", "END",
    "CASE", "WHEN",
    "TRUE", "FALSE",
    "NULL", "AND",
    "OR", "NOT",
    "ASC", "DESC",
    "ORDERBY",
    "PARTITION",
    "FIXED", "INCLUDE",
    "EXCLUDE",
    "PARAMETERS",
    "COMMENT",
    "IDENTIFIER",
    "PARAMETER",
    "PARAMETER_IN_BRACKETS",
    "PARAMETER_INCOMPLETE",
    "FIELDNAME",
    "FIELDNAME_INCOMPLETE",
    "STRINGLITERAL",
    "STRINGLITERAL_INCOMPLETE",
    "DATELITERAL",
    "DATELITERAL_INCOMPLETE",
    "INTEGER",
    "FLOAT", "RBRACKET",
    "LCBRACK",
    "RCBRACK",
    "LPAREN", "RPAREN",
    "COMMA", "COLON",
    "PLUS", "MINUS",
    "DIVIDE", "MULTIPLY",
    "MOD", "EXPONENT",
    "GT", "LT",
    "GTE", "LTE",
    "EQ", "NEQ",
    "WHITESPACE"];
// tslint:disable:no-trailing-whitespace
TableauExpressionParser.ruleNames = [
    "expressionEOF", "expression", "lodExpression", "scalarExpression", "validAnalyticsExpression",
    "multipleValidAnalyticsExpressions", "analyticsExpression", "orderbyDirection",
    "orderbyColumn", "orderbyColumns", "orderbyAnalyticsFunction", "orderbyExpression",
    "orderbyExpressionIncomplete", "partitionByColumn", "partitionByColumns",
    "partitionExpression", "partitionExpressionIncomplete", "lodGroupBy",
    "lodStatement", "lodStatementNestedExpressions", "lodStatementIncomplete",
    "lodStatementMissingBrackets", "lodStatementMissingLeftBracket", "lodStatementMissingRightBracket",
    "lodStatementMissingFixed", "lodStatementMissingColon", "lodStatementUnsupported",
    "comment", "multDivOps", "addSubOps", "comparisonOps", "ifStatement",
    "elseIfStatement", "elseStatement", "ifStatementIncomplete", "ifStatementMissingCondition",
    "ifStatementMissingThen", "ifStatementMissingThenExpression", "ifStatementMissingElse",
    "ifStatementMissingElseExpression", "ifStatementMissingEnd", "ifStatementMissingElseIf",
    "ifStatementMissingElseIfCondition", "ifStatementMissingElseIfThen", "ifStatementMissingElseIfThenExpression",
    "caseStatement", "whenStatement", "caseStatementIncomplete", "caseStatementMissingCaseExpression",
    "caseStatementMissingWhen", "caseStatementMissingWhenExpression", "caseStatementMissingThen",
    "caseStatementMissingThenExpression", "caseStatementMissingEnd", "multiRowFieldReference",
    "multiRowFunctionCall", "fieldReference", "fieldReferenceIncomplete",
    "functionCall", "functionArgs", "functionCallIncomplete", "functionCallMissingCloseParen",
    "literal", "dateLiteral", "stringLiteral", "integerLiteral", "floatLiteral",
    "booleanLiteral", "nullLiteral", "literalIncomplete", "dateLiteralIncomplete",
    "stringLiteralIncomplete",
];
TableauExpressionParser._serializedATN = [4, 1, 54, 1003, 2, 0, 7, 0,
    2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9,
    2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2,
    17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7, 20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24,
    7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2, 27, 7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7,
    31, 2, 32, 7, 32, 2, 33, 7, 33, 2, 34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 2, 37, 7, 37, 2, 38, 7, 38,
    2, 39, 7, 39, 2, 40, 7, 40, 2, 41, 7, 41, 2, 42, 7, 42, 2, 43, 7, 43, 2, 44, 7, 44, 2, 45, 7, 45, 2,
    46, 7, 46, 2, 47, 7, 47, 2, 48, 7, 48, 2, 49, 7, 49, 2, 50, 7, 50, 2, 51, 7, 51, 2, 52, 7, 52, 2, 53,
    7, 53, 2, 54, 7, 54, 2, 55, 7, 55, 2, 56, 7, 56, 2, 57, 7, 57, 2, 58, 7, 58, 2, 59, 7, 59, 2, 60, 7,
    60, 2, 61, 7, 61, 2, 62, 7, 62, 2, 63, 7, 63, 2, 64, 7, 64, 2, 65, 7, 65, 2, 66, 7, 66, 2, 67, 7, 67,
    2, 68, 7, 68, 2, 69, 7, 69, 2, 70, 7, 70, 2, 71, 7, 71, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 3, 1, 151,
    8, 1, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 3, 2, 165, 8, 2, 1, 2, 1, 2,
    5, 2, 169, 8, 2, 10, 2, 12, 2, 172, 9, 2, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1,
    3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 3, 3, 197, 8, 3, 1, 3, 1, 3, 1,
    3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1,
    3, 1, 3, 1, 3, 5, 3, 222, 8, 3, 10, 3, 12, 3, 225, 9, 3, 1, 4, 1, 4, 3, 4, 229, 8, 4, 1, 5, 1, 5, 1, 5,
    1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5,
    1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5,
    1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 3, 5, 276, 8, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5,
    1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 5, 5, 294, 8, 5, 10, 5, 12, 5, 297, 9, 5, 1, 6, 1, 6, 1, 6, 1,
    6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 3, 6, 315, 8, 6, 1, 6, 1, 6, 5,
    6, 319, 8, 6, 10, 6, 12, 6, 322, 9, 6, 1, 7, 1, 7, 1, 8, 1, 8, 3, 8, 328, 8, 8, 1, 9, 1, 9, 1, 9, 5, 9,
    333, 8, 9, 10, 9, 12, 9, 336, 9, 9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 11, 1, 11, 1, 11, 1, 11, 1, 11,
    1, 12, 1, 12, 3, 12, 349, 8, 12, 1, 12, 3, 12, 352, 8, 12, 1, 12, 3, 12, 355, 8, 12, 1, 12, 3, 12,
    358, 8, 12, 1, 12, 1, 12, 1, 12, 3, 12, 363, 8, 12, 1, 12, 3, 12, 366, 8, 12, 1, 12, 3, 12, 369,
    8, 12, 1, 12, 1, 12, 1, 12, 1, 12, 3, 12, 375, 8, 12, 1, 12, 3, 12, 378, 8, 12, 1, 12, 1, 12, 1, 12,
    1, 12, 1, 12, 3, 12, 385, 8, 12, 1, 12, 1, 12, 1, 12, 1, 12, 1, 12, 1, 12, 3, 12, 393, 8, 12, 1, 13,
    1, 13, 1, 14, 1, 14, 1, 14, 5, 14, 400, 8, 14, 10, 14, 12, 14, 403, 9, 14, 1, 15, 1, 15, 1, 15, 1,
    15, 1, 15, 1, 15, 1, 15, 1, 16, 1, 16, 3, 16, 414, 8, 16, 1, 16, 3, 16, 417, 8, 16, 1, 16, 3, 16,
    420, 8, 16, 1, 16, 3, 16, 423, 8, 16, 1, 16, 1, 16, 1, 16, 3, 16, 428, 8, 16, 1, 16, 3, 16, 431,
    8, 16, 1, 16, 3, 16, 434, 8, 16, 1, 16, 1, 16, 1, 16, 1, 16, 3, 16, 440, 8, 16, 1, 16, 3, 16, 443,
    8, 16, 1, 16, 1, 16, 1, 16, 1, 16, 1, 16, 3, 16, 450, 8, 16, 1, 16, 1, 16, 1, 16, 1, 16, 1, 16, 1,
    16, 3, 16, 458, 8, 16, 1, 16, 1, 16, 1, 16, 1, 16, 1, 16, 1, 16, 3, 16, 466, 8, 16, 1, 17, 1, 17,
    1, 17, 5, 17, 471, 8, 17, 10, 17, 12, 17, 474, 9, 17, 1, 18, 1, 18, 1, 18, 3, 18, 479, 8, 18, 1,
    18, 1, 18, 1, 18, 1, 18, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 3, 19,
    495, 8, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 3, 19, 508,
    8, 19, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 3, 20, 515, 8, 20, 1, 21, 1, 21, 1, 21, 1, 21, 5, 21, 521,
    8, 21, 10, 21, 12, 21, 524, 9, 21, 3, 21, 526, 8, 21, 1, 21, 1, 21, 1, 21, 1, 22, 1, 22, 1, 22, 1,
    22, 5, 22, 535, 8, 22, 10, 22, 12, 22, 538, 9, 22, 3, 22, 540, 8, 22, 1, 22, 1, 22, 1, 22, 1, 22,
    1, 23, 1, 23, 1, 23, 1, 23, 1, 23, 5, 23, 551, 8, 23, 10, 23, 12, 23, 554, 9, 23, 3, 23, 556, 8,
    23, 1, 23, 1, 23, 1, 23, 1, 24, 1, 24, 1, 24, 1, 24, 5, 24, 565, 8, 24, 10, 24, 12, 24, 568, 9, 24,
    3, 24, 570, 8, 24, 1, 24, 1, 24, 1, 24, 1, 24, 1, 25, 1, 25, 1, 25, 1, 25, 1, 25, 5, 25, 581, 8, 25,
    10, 25, 12, 25, 584, 9, 25, 3, 25, 586, 8, 25, 1, 25, 1, 25, 1, 25, 1, 26, 1, 26, 1, 26, 3, 26, 594,
    8, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 1, 26, 3, 26, 603, 8, 26, 1, 26, 1, 26, 1, 26, 1,
    26, 3, 26, 609, 8, 26, 1, 27, 1, 27, 1, 28, 1, 28, 1, 29, 1, 29, 1, 30, 1, 30, 1, 31, 1, 31, 1, 31,
    1, 31, 1, 31, 5, 31, 624, 8, 31, 10, 31, 12, 31, 627, 9, 31, 1, 31, 3, 31, 630, 8, 31, 1, 31, 1,
    31, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 1, 33, 1, 33, 1, 33, 1, 34, 1, 34, 1, 34, 1, 34, 1, 34, 1, 34,
    1, 34, 1, 34, 1, 34, 1, 34, 3, 34, 652, 8, 34, 1, 35, 1, 35, 3, 35, 656, 8, 35, 1, 35, 3, 35, 659,
    8, 35, 1, 35, 5, 35, 662, 8, 35, 10, 35, 12, 35, 665, 9, 35, 1, 35, 3, 35, 668, 8, 35, 1, 35, 3,
    35, 671, 8, 35, 1, 36, 1, 36, 1, 36, 3, 36, 676, 8, 36, 1, 36, 5, 36, 679, 8, 36, 10, 36, 12, 36,
    682, 9, 36, 1, 36, 3, 36, 685, 8, 36, 1, 36, 3, 36, 688, 8, 36, 1, 37, 1, 37, 1, 37, 1, 37, 5, 37,
    694, 8, 37, 10, 37, 12, 37, 697, 9, 37, 1, 37, 3, 37, 700, 8, 37, 1, 37, 3, 37, 703, 8, 37, 1, 38,
    1, 38, 1, 38, 1, 38, 1, 38, 5, 38, 710, 8, 38, 10, 38, 12, 38, 713, 9, 38, 1, 38, 3, 38, 716, 8,
    38, 1, 38, 3, 38, 719, 8, 38, 1, 39, 1, 39, 1, 39, 1, 39, 1, 39, 5, 39, 726, 8, 39, 10, 39, 12, 39,
    729, 9, 39, 1, 39, 1, 39, 3, 39, 733, 8, 39, 1, 40, 1, 40, 1, 40, 1, 40, 1, 40, 5, 40, 740, 8, 40,
    10, 40, 12, 40, 743, 9, 40, 1, 40, 3, 40, 746, 8, 40, 1, 41, 1, 41, 1, 41, 1, 41, 1, 41, 5, 41, 753,
    8, 41, 10, 41, 12, 41, 756, 9, 41, 1, 41, 3, 41, 759, 8, 41, 1, 41, 3, 41, 762, 8, 41, 1, 41, 3,
    41, 765, 8, 41, 1, 41, 5, 41, 768, 8, 41, 10, 41, 12, 41, 771, 9, 41, 1, 41, 3, 41, 774, 8, 41,
    1, 41, 3, 41, 777, 8, 41, 1, 42, 1, 42, 1, 42, 1, 42, 1, 42, 5, 42, 784, 8, 42, 10, 42, 12, 42, 787,
    9, 42, 1, 42, 1, 42, 3, 42, 791, 8, 42, 1, 42, 3, 42, 794, 8, 42, 1, 42, 5, 42, 797, 8, 42, 10, 42,
    12, 42, 800, 9, 42, 1, 42, 3, 42, 803, 8, 42, 1, 42, 3, 42, 806, 8, 42, 1, 43, 1, 43, 1, 43, 1, 43,
    1, 43, 5, 43, 813, 8, 43, 10, 43, 12, 43, 816, 9, 43, 1, 43, 1, 43, 1, 43, 3, 43, 821, 8, 43, 1,
    43, 5, 43, 824, 8, 43, 10, 43, 12, 43, 827, 9, 43, 1, 43, 3, 43, 830, 8, 43, 1, 43, 3, 43, 833,
    8, 43, 1, 44, 1, 44, 1, 44, 1, 44, 1, 44, 5, 44, 840, 8, 44, 10, 44, 12, 44, 843, 9, 44, 1, 44, 1,
    44, 1, 44, 1, 44, 5, 44, 849, 8, 44, 10, 44, 12, 44, 852, 9, 44, 1, 44, 3, 44, 855, 8, 44, 1, 44,
    3, 44, 858, 8, 44, 1, 45, 1, 45, 1, 45, 5, 45, 863, 8, 45, 10, 45, 12, 45, 866, 9, 45, 1, 45, 3,
    45, 869, 8, 45, 1, 45, 1, 45, 1, 46, 1, 46, 1, 46, 1, 46, 1, 46, 1, 47, 1, 47, 1, 47, 1, 47, 1, 47,
    1, 47, 3, 47, 884, 8, 47, 1, 48, 1, 48, 1, 49, 1, 49, 1, 49, 1, 50, 1, 50, 1, 50, 5, 50, 894, 8, 50,
    10, 50, 12, 50, 897, 9, 50, 1, 50, 1, 50, 1, 51, 1, 51, 1, 51, 5, 51, 904, 8, 51, 10, 51, 12, 51,
    907, 9, 51, 1, 51, 1, 51, 1, 51, 1, 52, 1, 52, 1, 52, 5, 52, 915, 8, 52, 10, 52, 12, 52, 918, 9,
    52, 1, 52, 1, 52, 1, 52, 1, 52, 1, 53, 1, 53, 1, 53, 5, 53, 927, 8, 53, 10, 53, 12, 53, 930, 9, 53,
    1, 53, 3, 53, 933, 8, 53, 1, 54, 1, 54, 1, 54, 1, 54, 1, 54, 3, 54, 940, 8, 54, 1, 55, 1, 55, 1, 55,
    1, 55, 1, 55, 3, 55, 947, 8, 55, 1, 56, 1, 56, 1, 57, 1, 57, 1, 58, 1, 58, 1, 58, 3, 58, 956, 8, 58,
    1, 58, 1, 58, 1, 59, 1, 59, 1, 59, 5, 59, 963, 8, 59, 10, 59, 12, 59, 966, 9, 59, 1, 60, 1, 60, 1,
    61, 1, 61, 1, 61, 3, 61, 973, 8, 61, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 1, 62, 3, 62, 981, 8, 62,
    1, 63, 1, 63, 1, 64, 1, 64, 1, 65, 1, 65, 1, 66, 1, 66, 1, 67, 1, 67, 1, 68, 1, 68, 1, 69, 1, 69, 3,
    69, 997, 8, 69, 1, 70, 1, 70, 1, 71, 1, 71, 1, 71, 0, 4, 4, 6, 10, 12, 72, 0, 2, 4, 6, 8, 10, 12, 14,
    16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62,
    64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108,
    110, 112, 114, 116, 118, 120, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 142, 0, 7,
    1, 0, 14, 15, 1, 0, 44, 46, 1, 0, 42, 43, 1, 0, 48, 53, 3, 0, 23, 23, 25, 25, 27, 27, 2, 0, 26, 26,
    28, 28, 1, 0, 8, 9, 1108, 0, 144, 1, 0, 0, 0, 2, 150, 1, 0, 0, 0, 4, 164, 1, 0, 0, 0, 6, 196, 1, 0,
    0, 0, 8, 228, 1, 0, 0, 0, 10, 275, 1, 0, 0, 0, 12, 314, 1, 0, 0, 0, 14, 323, 1, 0, 0, 0, 16, 325, 1,
    0, 0, 0, 18, 329, 1, 0, 0, 0, 20, 337, 1, 0, 0, 0, 22, 339, 1, 0, 0, 0, 24, 392, 1, 0, 0, 0, 26, 394,
    1, 0, 0, 0, 28, 396, 1, 0, 0, 0, 30, 404, 1, 0, 0, 0, 32, 465, 1, 0, 0, 0, 34, 467, 1, 0, 0, 0, 36,
    475, 1, 0, 0, 0, 38, 507, 1, 0, 0, 0, 40, 514, 1, 0, 0, 0, 42, 516, 1, 0, 0, 0, 44, 530, 1, 0, 0, 0,
    46, 545, 1, 0, 0, 0, 48, 560, 1, 0, 0, 0, 50, 575, 1, 0, 0, 0, 52, 608, 1, 0, 0, 0, 54, 610, 1, 0,
    0, 0, 56, 612, 1, 0, 0, 0, 58, 614, 1, 0, 0, 0, 60, 616, 1, 0, 0, 0, 62, 618, 1, 0, 0, 0, 64, 633,
    1, 0, 0, 0, 66, 638, 1, 0, 0, 0, 68, 651, 1, 0, 0, 0, 70, 653, 1, 0, 0, 0, 72, 672, 1, 0, 0, 0, 74,
    689, 1, 0, 0, 0, 76, 704, 1, 0, 0, 0, 78, 720, 1, 0, 0, 0, 80, 734, 1, 0, 0, 0, 82, 747, 1, 0, 0, 0,
    84, 778, 1, 0, 0, 0, 86, 807, 1, 0, 0, 0, 88, 834, 1, 0, 0, 0, 90, 859, 1, 0, 0, 0, 92, 872, 1, 0,
    0, 0, 94, 883, 1, 0, 0, 0, 96, 885, 1, 0, 0, 0, 98, 887, 1, 0, 0, 0, 100, 890, 1, 0, 0, 0, 102, 900,
    1, 0, 0, 0, 104, 911, 1, 0, 0, 0, 106, 923, 1, 0, 0, 0, 108, 939, 1, 0, 0, 0, 110, 946, 1, 0, 0, 0,
    112, 948, 1, 0, 0, 0, 114, 950, 1, 0, 0, 0, 116, 952, 1, 0, 0, 0, 118, 959, 1, 0, 0, 0, 120, 967,
    1, 0, 0, 0, 122, 969, 1, 0, 0, 0, 124, 980, 1, 0, 0, 0, 126, 982, 1, 0, 0, 0, 128, 984, 1, 0, 0, 0,
    130, 986, 1, 0, 0, 0, 132, 988, 1, 0, 0, 0, 134, 990, 1, 0, 0, 0, 136, 992, 1, 0, 0, 0, 138, 996,
    1, 0, 0, 0, 140, 998, 1, 0, 0, 0, 142, 1000, 1, 0, 0, 0, 144, 145, 3, 2, 1, 0, 145, 146, 5, 0, 0,
    1, 146, 1, 1, 0, 0, 0, 147, 151, 3, 4, 2, 0, 148, 151, 3, 12, 6, 0, 149, 151, 3, 6, 3, 0, 150, 147,
    1, 0, 0, 0, 150, 148, 1, 0, 0, 0, 150, 149, 1, 0, 0, 0, 151, 3, 1, 0, 0, 0, 152, 153, 6, 2, -1, 0,
    153, 165, 3, 36, 18, 0, 154, 155, 5, 38, 0, 0, 155, 156, 3, 4, 2, 0, 156, 157, 5, 39, 0, 0, 157,
    165, 1, 0, 0, 0, 158, 165, 3, 40, 20, 0, 159, 165, 3, 52, 26, 0, 160, 161, 3, 54, 27, 0, 161, 162,
    3, 4, 2, 3, 162, 165, 1, 0, 0, 0, 163, 165, 3, 38, 19, 0, 164, 152, 1, 0, 0, 0, 164, 154, 1, 0, 0,
    0, 164, 158, 1, 0, 0, 0, 164, 159, 1, 0, 0, 0, 164, 160, 1, 0, 0, 0, 164, 163, 1, 0, 0, 0, 165, 170,
    1, 0, 0, 0, 166, 167, 10, 2, 0, 0, 167, 169, 3, 54, 27, 0, 168, 166, 1, 0, 0, 0, 169, 172, 1, 0,
    0, 0, 170, 168, 1, 0, 0, 0, 170, 171, 1, 0, 0, 0, 171, 5, 1, 0, 0, 0, 172, 170, 1, 0, 0, 0, 173, 174,
    6, 3, -1, 0, 174, 175, 3, 54, 27, 0, 175, 176, 3, 6, 3, 22, 176, 197, 1, 0, 0, 0, 177, 178, 5, 38,
    0, 0, 178, 179, 3, 6, 3, 0, 179, 180, 5, 39, 0, 0, 180, 197, 1, 0, 0, 0, 181, 182, 5, 43, 0, 0, 182,
    197, 3, 6, 3, 20, 183, 184, 5, 13, 0, 0, 184, 197, 3, 6, 3, 15, 185, 197, 3, 62, 31, 0, 186, 197,
    3, 68, 34, 0, 187, 197, 3, 90, 45, 0, 188, 197, 3, 94, 47, 0, 189, 197, 3, 112, 56, 0, 190, 197,
    3, 114, 57, 0, 191, 197, 3, 116, 58, 0, 192, 197, 3, 120, 60, 0, 193, 197, 3, 124, 62, 0, 194,
    197, 3, 138, 69, 0, 195, 197, 3, 4, 2, 0, 196, 173, 1, 0, 0, 0, 196, 177, 1, 0, 0, 0, 196, 181,
    1, 0, 0, 0, 196, 183, 1, 0, 0, 0, 196, 185, 1, 0, 0, 0, 196, 186, 1, 0, 0, 0, 196, 187, 1, 0, 0, 0,
    196, 188, 1, 0, 0, 0, 196, 189, 1, 0, 0, 0, 196, 190, 1, 0, 0, 0, 196, 191, 1, 0, 0, 0, 196, 192,
    1, 0, 0, 0, 196, 193, 1, 0, 0, 0, 196, 194, 1, 0, 0, 0, 196, 195, 1, 0, 0, 0, 197, 223, 1, 0, 0, 0,
    198, 199, 10, 19, 0, 0, 199, 200, 5, 47, 0, 0, 200, 222, 3, 6, 3, 20, 201, 202, 10, 18, 0, 0, 202,
    203, 3, 56, 28, 0, 203, 204, 3, 6, 3, 19, 204, 222, 1, 0, 0, 0, 205, 206, 10, 17, 0, 0, 206, 207,
    3, 58, 29, 0, 207, 208, 3, 6, 3, 18, 208, 222, 1, 0, 0, 0, 209, 210, 10, 16, 0, 0, 210, 211, 3,
    60, 30, 0, 211, 212, 3, 6, 3, 17, 212, 222, 1, 0, 0, 0, 213, 214, 10, 14, 0, 0, 214, 215, 5, 11,
    0, 0, 215, 222, 3, 6, 3, 15, 216, 217, 10, 13, 0, 0, 217, 218, 5, 12, 0, 0, 218, 222, 3, 6, 3, 14,
    219, 220, 10, 2, 0, 0, 220, 222, 3, 54, 27, 0, 221, 198, 1, 0, 0, 0, 221, 201, 1, 0, 0, 0, 221,
    205, 1, 0, 0, 0, 221, 209, 1, 0, 0, 0, 221, 213, 1, 0, 0, 0, 221, 216, 1, 0, 0, 0, 221, 219, 1, 0,
    0, 0, 222, 225, 1, 0, 0, 0, 223, 221, 1, 0, 0, 0, 223, 224, 1, 0, 0, 0, 224, 7, 1, 0, 0, 0, 225, 223,
    1, 0, 0, 0, 226, 229, 3, 22, 11, 0, 227, 229, 3, 30, 15, 0, 228, 226, 1, 0, 0, 0, 228, 227, 1, 0,
    0, 0, 229, 9, 1, 0, 0, 0, 230, 231, 6, 5, -1, 0, 231, 232, 3, 8, 4, 0, 232, 233, 3, 58, 29, 0, 233,
    234, 3, 8, 4, 0, 234, 276, 1, 0, 0, 0, 235, 236, 3, 8, 4, 0, 236, 237, 3, 56, 28, 0, 237, 238, 3,
    8, 4, 0, 238, 276, 1, 0, 0, 0, 239, 240, 5, 38, 0, 0, 240, 241, 3, 8, 4, 0, 241, 242, 3, 58, 29,
    0, 242, 243, 3, 8, 4, 0, 243, 244, 5, 39, 0, 0, 244, 276, 1, 0, 0, 0, 245, 246, 5, 38, 0, 0, 246,
    247, 3, 8, 4, 0, 247, 248, 3, 56, 28, 0, 248, 249, 3, 8, 4, 0, 249, 250, 5, 39, 0, 0, 250, 276,
    1, 0, 0, 0, 251, 252, 5, 38, 0, 0, 252, 253, 3, 10, 5, 0, 253, 254, 3, 58, 29, 0, 254, 255, 3, 8,
    4, 0, 255, 256, 5, 39, 0, 0, 256, 276, 1, 0, 0, 0, 257, 258, 5, 38, 0, 0, 258, 259, 3, 10, 5, 0,
    259, 260, 3, 56, 28, 0, 260, 261, 3, 8, 4, 0, 261, 262, 5, 39, 0, 0, 262, 276, 1, 0, 0, 0, 263,
    264, 5, 38, 0, 0, 264, 265, 3, 10, 5, 0, 265, 266, 3, 56, 28, 0, 266, 267, 3, 132, 66, 0, 267,
    268, 5, 39, 0, 0, 268, 276, 1, 0, 0, 0, 269, 270, 5, 38, 0, 0, 270, 271, 3, 10, 5, 0, 271, 272,
    3, 56, 28, 0, 272, 273, 3, 130, 65, 0, 273, 274, 5, 39, 0, 0, 274, 276, 1, 0, 0, 0, 275, 230, 1,
    0, 0, 0, 275, 235, 1, 0, 0, 0, 275, 239, 1, 0, 0, 0, 275, 245, 1, 0, 0, 0, 275, 251, 1, 0, 0, 0, 275,
    257, 1, 0, 0, 0, 275, 263, 1, 0, 0, 0, 275, 269, 1, 0, 0, 0, 276, 295, 1, 0, 0, 0, 277, 278, 10,
    10, 0, 0, 278, 279, 3, 58, 29, 0, 279, 280, 3, 8, 4, 0, 280, 294, 1, 0, 0, 0, 281, 282, 10, 9, 0,
    0, 282, 283, 3, 56, 28, 0, 283, 284, 3, 8, 4, 0, 284, 294, 1, 0, 0, 0, 285, 286, 10, 8, 0, 0, 286,
    287, 3, 56, 28, 0, 287, 288, 3, 132, 66, 0, 288, 294, 1, 0, 0, 0, 289, 290, 10, 7, 0, 0, 290, 291,
    3, 56, 28, 0, 291, 292, 3, 130, 65, 0, 292, 294, 1, 0, 0, 0, 293, 277, 1, 0, 0, 0, 293, 281, 1,
    0, 0, 0, 293, 285, 1, 0, 0, 0, 293, 289, 1, 0, 0, 0, 294, 297, 1, 0, 0, 0, 295, 293, 1, 0, 0, 0, 295,
    296, 1, 0, 0, 0, 296, 11, 1, 0, 0, 0, 297, 295, 1, 0, 0, 0, 298, 299, 6, 6, -1, 0, 299, 315, 3, 8,
    4, 0, 300, 301, 5, 38, 0, 0, 301, 302, 3, 12, 6, 0, 302, 303, 5, 39, 0, 0, 303, 315, 1, 0, 0, 0,
    304, 315, 3, 24, 12, 0, 305, 315, 3, 32, 16, 0, 306, 307, 3, 54, 27, 0, 307, 308, 3, 12, 6, 4,
    308, 315, 1, 0, 0, 0, 309, 315, 3, 10, 5, 0, 310, 311, 5, 38, 0, 0, 311, 312, 3, 10, 5, 0, 312,
    313, 5, 39, 0, 0, 313, 315, 1, 0, 0, 0, 314, 298, 1, 0, 0, 0, 314, 300, 1, 0, 0, 0, 314, 304, 1,
    0, 0, 0, 314, 305, 1, 0, 0, 0, 314, 306, 1, 0, 0, 0, 314, 309, 1, 0, 0, 0, 314, 310, 1, 0, 0, 0, 315,
    320, 1, 0, 0, 0, 316, 317, 10, 3, 0, 0, 317, 319, 3, 54, 27, 0, 318, 316, 1, 0, 0, 0, 319, 322,
    1, 0, 0, 0, 320, 318, 1, 0, 0, 0, 320, 321, 1, 0, 0, 0, 321, 13, 1, 0, 0, 0, 322, 320, 1, 0, 0, 0,
    323, 324, 7, 0, 0, 0, 324, 15, 1, 0, 0, 0, 325, 327, 3, 108, 54, 0, 326, 328, 3, 14, 7, 0, 327,
    326, 1, 0, 0, 0, 327, 328, 1, 0, 0, 0, 328, 17, 1, 0, 0, 0, 329, 334, 3, 16, 8, 0, 330, 331, 5, 40,
    0, 0, 331, 333, 3, 16, 8, 0, 332, 330, 1, 0, 0, 0, 333, 336, 1, 0, 0, 0, 334, 332, 1, 0, 0, 0, 334,
    335, 1, 0, 0, 0, 335, 19, 1, 0, 0, 0, 336, 334, 1, 0, 0, 0, 337, 338, 3, 110, 55, 0, 338, 21, 1,
    0, 0, 0, 339, 340, 5, 36, 0, 0, 340, 341, 5, 16, 0, 0, 341, 342, 3, 18, 9, 0, 342, 343, 5, 41, 0,
    0, 343, 344, 3, 20, 10, 0, 344, 345, 5, 37, 0, 0, 345, 23, 1, 0, 0, 0, 346, 348, 5, 16, 0, 0, 347,
    349, 3, 18, 9, 0, 348, 347, 1, 0, 0, 0, 348, 349, 1, 0, 0, 0, 349, 351, 1, 0, 0, 0, 350, 352, 5,
    41, 0, 0, 351, 350, 1, 0, 0, 0, 351, 352, 1, 0, 0, 0, 352, 354, 1, 0, 0, 0, 353, 355, 3, 20, 10,
    0, 354, 353, 1, 0, 0, 0, 354, 355, 1, 0, 0, 0, 355, 357, 1, 0, 0, 0, 356, 358, 5, 37, 0, 0, 357,
    356, 1, 0, 0, 0, 357, 358, 1, 0, 0, 0, 358, 393, 1, 0, 0, 0, 359, 360, 5, 36, 0, 0, 360, 362, 5,
    16, 0, 0, 361, 363, 5, 41, 0, 0, 362, 361, 1, 0, 0, 0, 362, 363, 1, 0, 0, 0, 363, 365, 1, 0, 0, 0,
    364, 366, 3, 20, 10, 0, 365, 364, 1, 0, 0, 0, 365, 366, 1, 0, 0, 0, 366, 368, 1, 0, 0, 0, 367, 369,
    5, 37, 0, 0, 368, 367, 1, 0, 0, 0, 368, 369, 1, 0, 0, 0, 369, 393, 1, 0, 0, 0, 370, 371, 5, 36, 0,
    0, 371, 372, 5, 16, 0, 0, 372, 374, 3, 18, 9, 0, 373, 375, 3, 20, 10, 0, 374, 373, 1, 0, 0, 0, 374,
    375, 1, 0, 0, 0, 375, 377, 1, 0, 0, 0, 376, 378, 5, 37, 0, 0, 377, 376, 1, 0, 0, 0, 377, 378, 1,
    0, 0, 0, 378, 393, 1, 0, 0, 0, 379, 380, 5, 36, 0, 0, 380, 381, 5, 16, 0, 0, 381, 382, 3, 18, 9,
    0, 382, 384, 5, 41, 0, 0, 383, 385, 5, 37, 0, 0, 384, 383, 1, 0, 0, 0, 384, 385, 1, 0, 0, 0, 385,
    393, 1, 0, 0, 0, 386, 387, 5, 36, 0, 0, 387, 388, 5, 16, 0, 0, 388, 389, 3, 18, 9, 0, 389, 390,
    5, 41, 0, 0, 390, 391, 3, 20, 10, 0, 391, 393, 1, 0, 0, 0, 392, 346, 1, 0, 0, 0, 392, 359, 1, 0,
    0, 0, 392, 370, 1, 0, 0, 0, 392, 379, 1, 0, 0, 0, 392, 386, 1, 0, 0, 0, 393, 25, 1, 0, 0, 0, 394,
    395, 3, 108, 54, 0, 395, 27, 1, 0, 0, 0, 396, 401, 3, 26, 13, 0, 397, 398, 5, 40, 0, 0, 398, 400,
    3, 28, 14, 0, 399, 397, 1, 0, 0, 0, 400, 403, 1, 0, 0, 0, 401, 399, 1, 0, 0, 0, 401, 402, 1, 0, 0,
    0, 402, 29, 1, 0, 0, 0, 403, 401, 1, 0, 0, 0, 404, 405, 5, 36, 0, 0, 405, 406, 5, 17, 0, 0, 406,
    407, 3, 28, 14, 0, 407, 408, 5, 41, 0, 0, 408, 409, 3, 22, 11, 0, 409, 410, 5, 37, 0, 0, 410, 31,
    1, 0, 0, 0, 411, 413, 5, 17, 0, 0, 412, 414, 3, 28, 14, 0, 413, 412, 1, 0, 0, 0, 413, 414, 1, 0,
    0, 0, 414, 416, 1, 0, 0, 0, 415, 417, 5, 41, 0, 0, 416, 415, 1, 0, 0, 0, 416, 417, 1, 0, 0, 0, 417,
    419, 1, 0, 0, 0, 418, 420, 3, 22, 11, 0, 419, 418, 1, 0, 0, 0, 419, 420, 1, 0, 0, 0, 420, 422, 1,
    0, 0, 0, 421, 423, 5, 37, 0, 0, 422, 421, 1, 0, 0, 0, 422, 423, 1, 0, 0, 0, 423, 466, 1, 0, 0, 0,
    424, 425, 5, 36, 0, 0, 425, 427, 5, 17, 0, 0, 426, 428, 5, 41, 0, 0, 427, 426, 1, 0, 0, 0, 427,
    428, 1, 0, 0, 0, 428, 430, 1, 0, 0, 0, 429, 431, 3, 22, 11, 0, 430, 429, 1, 0, 0, 0, 430, 431, 1,
    0, 0, 0, 431, 433, 1, 0, 0, 0, 432, 434, 5, 37, 0, 0, 433, 432, 1, 0, 0, 0, 433, 434, 1, 0, 0, 0,
    434, 466, 1, 0, 0, 0, 435, 436, 5, 36, 0, 0, 436, 437, 5, 17, 0, 0, 437, 439, 3, 28, 14, 0, 438,
    440, 3, 22, 11, 0, 439, 438, 1, 0, 0, 0, 439, 440, 1, 0, 0, 0, 440, 442, 1, 0, 0, 0, 441, 443, 5,
    37, 0, 0, 442, 441, 1, 0, 0, 0, 442, 443, 1, 0, 0, 0, 443, 466, 1, 0, 0, 0, 444, 445, 5, 36, 0, 0,
    445, 446, 5, 17, 0, 0, 446, 447, 3, 28, 14, 0, 447, 449, 5, 41, 0, 0, 448, 450, 5, 37, 0, 0, 449,
    448, 1, 0, 0, 0, 449, 450, 1, 0, 0, 0, 450, 466, 1, 0, 0, 0, 451, 452, 5, 36, 0, 0, 452, 453, 5,
    17, 0, 0, 453, 454, 3, 28, 14, 0, 454, 455, 5, 41, 0, 0, 455, 457, 3, 24, 12, 0, 456, 458, 5, 37,
    0, 0, 457, 456, 1, 0, 0, 0, 457, 458, 1, 0, 0, 0, 458, 466, 1, 0, 0, 0, 459, 460, 5, 36, 0, 0, 460,
    461, 5, 17, 0, 0, 461, 462, 3, 28, 14, 0, 462, 463, 5, 41, 0, 0, 463, 464, 3, 22, 11, 0, 464, 466,
    1, 0, 0, 0, 465, 411, 1, 0, 0, 0, 465, 424, 1, 0, 0, 0, 465, 435, 1, 0, 0, 0, 465, 444, 1, 0, 0, 0,
    465, 451, 1, 0, 0, 0, 465, 459, 1, 0, 0, 0, 466, 33, 1, 0, 0, 0, 467, 472, 3, 108, 54, 0, 468, 469,
    5, 40, 0, 0, 469, 471, 3, 34, 17, 0, 470, 468, 1, 0, 0, 0, 471, 474, 1, 0, 0, 0, 472, 470, 1, 0,
    0, 0, 472, 473, 1, 0, 0, 0, 473, 35, 1, 0, 0, 0, 474, 472, 1, 0, 0, 0, 475, 476, 5, 36, 0, 0, 476,
    478, 5, 18, 0, 0, 477, 479, 3, 34, 17, 0, 478, 477, 1, 0, 0, 0, 478, 479, 1, 0, 0, 0, 479, 480,
    1, 0, 0, 0, 480, 481, 5, 41, 0, 0, 481, 482, 3, 110, 55, 0, 482, 483, 5, 37, 0, 0, 483, 37, 1, 0,
    0, 0, 484, 485, 5, 36, 0, 0, 485, 486, 5, 18, 0, 0, 486, 487, 3, 2, 1, 0, 487, 488, 5, 41, 0, 0,
    488, 489, 3, 116, 58, 0, 489, 490, 5, 37, 0, 0, 490, 508, 1, 0, 0, 0, 491, 492, 5, 36, 0, 0, 492,
    494, 5, 18, 0, 0, 493, 495, 3, 34, 17, 0, 494, 493, 1, 0, 0, 0, 494, 495, 1, 0, 0, 0, 495, 496,
    1, 0, 0, 0, 496, 497, 5, 41, 0, 0, 497, 498, 3, 2, 1, 0, 498, 499, 5, 37, 0, 0, 499, 508, 1, 0, 0,
    0, 500, 501, 5, 36, 0, 0, 501, 502, 5, 18, 0, 0, 502, 503, 3, 2, 1, 0, 503, 504, 5, 41, 0, 0, 504,
    505, 3, 2, 1, 0, 505, 506, 5, 37, 0, 0, 506, 508, 1, 0, 0, 0, 507, 484, 1, 0, 0, 0, 507, 491, 1,
    0, 0, 0, 507, 500, 1, 0, 0, 0, 508, 39, 1, 0, 0, 0, 509, 515, 3, 42, 21, 0, 510, 515, 3, 44, 22,
    0, 511, 515, 3, 46, 23, 0, 512, 515, 3, 48, 24, 0, 513, 515, 3, 50, 25, 0, 514, 509, 1, 0, 0, 0,
    514, 510, 1, 0, 0, 0, 514, 511, 1, 0, 0, 0, 514, 512, 1, 0, 0, 0, 514, 513, 1, 0, 0, 0, 515, 41,
    1, 0, 0, 0, 516, 525, 5, 18, 0, 0, 517, 522, 3, 112, 56, 0, 518, 519, 5, 40, 0, 0, 519, 521, 3,
    112, 56, 0, 520, 518, 1, 0, 0, 0, 521, 524, 1, 0, 0, 0, 522, 520, 1, 0, 0, 0, 522, 523, 1, 0, 0,
    0, 523, 526, 1, 0, 0, 0, 524, 522, 1, 0, 0, 0, 525, 517, 1, 0, 0, 0, 525, 526, 1, 0, 0, 0, 526, 527,
    1, 0, 0, 0, 527, 528, 5, 41, 0, 0, 528, 529, 3, 116, 58, 0, 529, 43, 1, 0, 0, 0, 530, 539, 5, 18,
    0, 0, 531, 536, 3, 112, 56, 0, 532, 533, 5, 40, 0, 0, 533, 535, 3, 112, 56, 0, 534, 532, 1, 0,
    0, 0, 535, 538, 1, 0, 0, 0, 536, 534, 1, 0, 0, 0, 536, 537, 1, 0, 0, 0, 537, 540, 1, 0, 0, 0, 538,
    536, 1, 0, 0, 0, 539, 531, 1, 0, 0, 0, 539, 540, 1, 0, 0, 0, 540, 541, 1, 0, 0, 0, 541, 542, 5, 41,
    0, 0, 542, 543, 3, 116, 58, 0, 543, 544, 5, 37, 0, 0, 544, 45, 1, 0, 0, 0, 545, 546, 5, 36, 0, 0,
    546, 555, 5, 18, 0, 0, 547, 552, 3, 112, 56, 0, 548, 549, 5, 40, 0, 0, 549, 551, 3, 112, 56, 0,
    550, 548, 1, 0, 0, 0, 551, 554, 1, 0, 0, 0, 552, 550, 1, 0, 0, 0, 552, 553, 1, 0, 0, 0, 553, 556,
    1, 0, 0, 0, 554, 552, 1, 0, 0, 0, 555, 547, 1, 0, 0, 0, 555, 556, 1, 0, 0, 0, 556, 557, 1, 0, 0, 0,
    557, 558, 5, 41, 0, 0, 558, 559, 3, 116, 58, 0, 559, 47, 1, 0, 0, 0, 560, 569, 5, 36, 0, 0, 561,
    566, 3, 112, 56, 0, 562, 563, 5, 40, 0, 0, 563, 565, 3, 112, 56, 0, 564, 562, 1, 0, 0, 0, 565,
    568, 1, 0, 0, 0, 566, 564, 1, 0, 0, 0, 566, 567, 1, 0, 0, 0, 567, 570, 1, 0, 0, 0, 568, 566, 1, 0,
    0, 0, 569, 561, 1, 0, 0, 0, 569, 570, 1, 0, 0, 0, 570, 571, 1, 0, 0, 0, 571, 572, 5, 41, 0, 0, 572,
    573, 3, 116, 58, 0, 573, 574, 5, 37, 0, 0, 574, 49, 1, 0, 0, 0, 575, 576, 5, 36, 0, 0, 576, 585,
    5, 18, 0, 0, 577, 582, 3, 112, 56, 0, 578, 579, 5, 40, 0, 0, 579, 581, 3, 112, 56, 0, 580, 578,
    1, 0, 0, 0, 581, 584, 1, 0, 0, 0, 582, 580, 1, 0, 0, 0, 582, 583, 1, 0, 0, 0, 583, 586, 1, 0, 0, 0,
    584, 582, 1, 0, 0, 0, 585, 577, 1, 0, 0, 0, 585, 586, 1, 0, 0, 0, 586, 587, 1, 0, 0, 0, 587, 588,
    3, 116, 58, 0, 588, 589, 5, 37, 0, 0, 589, 51, 1, 0, 0, 0, 590, 591, 5, 36, 0, 0, 591, 593, 5, 19,
    0, 0, 592, 594, 3, 34, 17, 0, 593, 592, 1, 0, 0, 0, 593, 594, 1, 0, 0, 0, 594, 595, 1, 0, 0, 0, 595,
    596, 5, 41, 0, 0, 596, 597, 3, 116, 58, 0, 597, 598, 5, 37, 0, 0, 598, 609, 1, 0, 0, 0, 599, 600,
    5, 36, 0, 0, 600, 602, 5, 20, 0, 0, 601, 603, 3, 34, 17, 0, 602, 601, 1, 0, 0, 0, 602, 603, 1, 0,
    0, 0, 603, 604, 1, 0, 0, 0, 604, 605, 5, 41, 0, 0, 605, 606, 3, 116, 58, 0, 606, 607, 5, 37, 0,
    0, 607, 609, 1, 0, 0, 0, 608, 590, 1, 0, 0, 0, 608, 599, 1, 0, 0, 0, 609, 53, 1, 0, 0, 0, 610, 611,
    5, 22, 0, 0, 611, 55, 1, 0, 0, 0, 612, 613, 7, 1, 0, 0, 613, 57, 1, 0, 0, 0, 614, 615, 7, 2, 0, 0,
    615, 59, 1, 0, 0, 0, 616, 617, 7, 3, 0, 0, 617, 61, 1, 0, 0, 0, 618, 619, 5, 1, 0, 0, 619, 620, 3,
    6, 3, 0, 620, 621, 5, 2, 0, 0, 621, 625, 3, 6, 3, 0, 622, 624, 3, 64, 32, 0, 623, 622, 1, 0, 0, 0,
    624, 627, 1, 0, 0, 0, 625, 623, 1, 0, 0, 0, 625, 626, 1, 0, 0, 0, 626, 629, 1, 0, 0, 0, 627, 625,
    1, 0, 0, 0, 628, 630, 3, 66, 33, 0, 629, 628, 1, 0, 0, 0, 629, 630, 1, 0, 0, 0, 630, 631, 1, 0, 0,
    0, 631, 632, 5, 5, 0, 0, 632, 63, 1, 0, 0, 0, 633, 634, 5, 4, 0, 0, 634, 635, 3, 6, 3, 0, 635, 636,
    5, 2, 0, 0, 636, 637, 3, 6, 3, 0, 637, 65, 1, 0, 0, 0, 638, 639, 5, 3, 0, 0, 639, 640, 3, 6, 3, 0,
    640, 67, 1, 0, 0, 0, 641, 652, 3, 70, 35, 0, 642, 652, 3, 72, 36, 0, 643, 652, 3, 74, 37, 0, 644,
    652, 3, 80, 40, 0, 645, 652, 3, 76, 38, 0, 646, 652, 3, 78, 39, 0, 647, 652, 3, 82, 41, 0, 648,
    652, 3, 84, 42, 0, 649, 652, 3, 86, 43, 0, 650, 652, 3, 88, 44, 0, 651, 641, 1, 0, 0, 0, 651, 642,
    1, 0, 0, 0, 651, 643, 1, 0, 0, 0, 651, 644, 1, 0, 0, 0, 651, 645, 1, 0, 0, 0, 651, 646, 1, 0, 0, 0,
    651, 647, 1, 0, 0, 0, 651, 648, 1, 0, 0, 0, 651, 649, 1, 0, 0, 0, 651, 650, 1, 0, 0, 0, 652, 69,
    1, 0, 0, 0, 653, 655, 5, 1, 0, 0, 654, 656, 5, 2, 0, 0, 655, 654, 1, 0, 0, 0, 655, 656, 1, 0, 0, 0,
    656, 658, 1, 0, 0, 0, 657, 659, 3, 6, 3, 0, 658, 657, 1, 0, 0, 0, 658, 659, 1, 0, 0, 0, 659, 663,
    1, 0, 0, 0, 660, 662, 3, 64, 32, 0, 661, 660, 1, 0, 0, 0, 662, 665, 1, 0, 0, 0, 663, 661, 1, 0, 0,
    0, 663, 664, 1, 0, 0, 0, 664, 667, 1, 0, 0, 0, 665, 663, 1, 0, 0, 0, 666, 668, 3, 66, 33, 0, 667,
    666, 1, 0, 0, 0, 667, 668, 1, 0, 0, 0, 668, 670, 1, 0, 0, 0, 669, 671, 5, 5, 0, 0, 670, 669, 1, 0,
    0, 0, 670, 671, 1, 0, 0, 0, 671, 71, 1, 0, 0, 0, 672, 673, 5, 1, 0, 0, 673, 675, 3, 6, 3, 0, 674,
    676, 3, 6, 3, 0, 675, 674, 1, 0, 0, 0, 675, 676, 1, 0, 0, 0, 676, 680, 1, 0, 0, 0, 677, 679, 3, 64,
    32, 0, 678, 677, 1, 0, 0, 0, 679, 682, 1, 0, 0, 0, 680, 678, 1, 0, 0, 0, 680, 681, 1, 0, 0, 0, 681,
    684, 1, 0, 0, 0, 682, 680, 1, 0, 0, 0, 683, 685, 3, 66, 33, 0, 684, 683, 1, 0, 0, 0, 684, 685, 1,
    0, 0, 0, 685, 687, 1, 0, 0, 0, 686, 688, 5, 5, 0, 0, 687, 686, 1, 0, 0, 0, 687, 688, 1, 0, 0, 0, 688,
    73, 1, 0, 0, 0, 689, 690, 5, 1, 0, 0, 690, 691, 3, 6, 3, 0, 691, 695, 5, 2, 0, 0, 692, 694, 3, 64,
    32, 0, 693, 692, 1, 0, 0, 0, 694, 697, 1, 0, 0, 0, 695, 693, 1, 0, 0, 0, 695, 696, 1, 0, 0, 0, 696,
    699, 1, 0, 0, 0, 697, 695, 1, 0, 0, 0, 698, 700, 3, 66, 33, 0, 699, 698, 1, 0, 0, 0, 699, 700, 1,
    0, 0, 0, 700, 702, 1, 0, 0, 0, 701, 703, 5, 5, 0, 0, 702, 701, 1, 0, 0, 0, 702, 703, 1, 0, 0, 0, 703,
    75, 1, 0, 0, 0, 704, 705, 5, 1, 0, 0, 705, 706, 3, 6, 3, 0, 706, 707, 5, 2, 0, 0, 707, 711, 3, 6,
    3, 0, 708, 710, 3, 64, 32, 0, 709, 708, 1, 0, 0, 0, 710, 713, 1, 0, 0, 0, 711, 709, 1, 0, 0, 0, 711,
    712, 1, 0, 0, 0, 712, 715, 1, 0, 0, 0, 713, 711, 1, 0, 0, 0, 714, 716, 3, 6, 3, 0, 715, 714, 1, 0,
    0, 0, 715, 716, 1, 0, 0, 0, 716, 718, 1, 0, 0, 0, 717, 719, 5, 5, 0, 0, 718, 717, 1, 0, 0, 0, 718,
    719, 1, 0, 0, 0, 719, 77, 1, 0, 0, 0, 720, 721, 5, 1, 0, 0, 721, 722, 3, 6, 3, 0, 722, 723, 5, 2,
    0, 0, 723, 727, 3, 6, 3, 0, 724, 726, 3, 64, 32, 0, 725, 724, 1, 0, 0, 0, 726, 729, 1, 0, 0, 0, 727,
    725, 1, 0, 0, 0, 727, 728, 1, 0, 0, 0, 728, 730, 1, 0, 0, 0, 729, 727, 1, 0, 0, 0, 730, 732, 5, 3,
    0, 0, 731, 733, 5, 5, 0, 0, 732, 731, 1, 0, 0, 0, 732, 733, 1, 0, 0, 0, 733, 79, 1, 0, 0, 0, 734,
    735, 5, 1, 0, 0, 735, 736, 3, 6, 3, 0, 736, 737, 5, 2, 0, 0, 737, 741, 3, 6, 3, 0, 738, 740, 3, 64,
    32, 0, 739, 738, 1, 0, 0, 0, 740, 743, 1, 0, 0, 0, 741, 739, 1, 0, 0, 0, 741, 742, 1, 0, 0, 0, 742,
    745, 1, 0, 0, 0, 743, 741, 1, 0, 0, 0, 744, 746, 3, 66, 33, 0, 745, 744, 1, 0, 0, 0, 745, 746, 1,
    0, 0, 0, 746, 81, 1, 0, 0, 0, 747, 748, 5, 1, 0, 0, 748, 749, 3, 6, 3, 0, 749, 750, 5, 2, 0, 0, 750,
    754, 3, 6, 3, 0, 751, 753, 3, 64, 32, 0, 752, 751, 1, 0, 0, 0, 753, 756, 1, 0, 0, 0, 754, 752, 1,
    0, 0, 0, 754, 755, 1, 0, 0, 0, 755, 758, 1, 0, 0, 0, 756, 754, 1, 0, 0, 0, 757, 759, 3, 6, 3, 0, 758,
    757, 1, 0, 0, 0, 758, 759, 1, 0, 0, 0, 759, 761, 1, 0, 0, 0, 760, 762, 5, 2, 0, 0, 761, 760, 1, 0,
    0, 0, 761, 762, 1, 0, 0, 0, 762, 764, 1, 0, 0, 0, 763, 765, 3, 6, 3, 0, 764, 763, 1, 0, 0, 0, 764,
    765, 1, 0, 0, 0, 765, 769, 1, 0, 0, 0, 766, 768, 3, 64, 32, 0, 767, 766, 1, 0, 0, 0, 768, 771, 1,
    0, 0, 0, 769, 767, 1, 0, 0, 0, 769, 770, 1, 0, 0, 0, 770, 773, 1, 0, 0, 0, 771, 769, 1, 0, 0, 0, 772,
    774, 3, 66, 33, 0, 773, 772, 1, 0, 0, 0, 773, 774, 1, 0, 0, 0, 774, 776, 1, 0, 0, 0, 775, 777, 5,
    5, 0, 0, 776, 775, 1, 0, 0, 0, 776, 777, 1, 0, 0, 0, 777, 83, 1, 0, 0, 0, 778, 779, 5, 1, 0, 0, 779,
    780, 3, 6, 3, 0, 780, 781, 5, 2, 0, 0, 781, 785, 3, 6, 3, 0, 782, 784, 3, 64, 32, 0, 783, 782, 1,
    0, 0, 0, 784, 787, 1, 0, 0, 0, 785, 783, 1, 0, 0, 0, 785, 786, 1, 0, 0, 0, 786, 788, 1, 0, 0, 0, 787,
    785, 1, 0, 0, 0, 788, 790, 5, 4, 0, 0, 789, 791, 5, 2, 0, 0, 790, 789, 1, 0, 0, 0, 790, 791, 1, 0,
    0, 0, 791, 793, 1, 0, 0, 0, 792, 794, 3, 6, 3, 0, 793, 792, 1, 0, 0, 0, 793, 794, 1, 0, 0, 0, 794,
    798, 1, 0, 0, 0, 795, 797, 3, 64, 32, 0, 796, 795, 1, 0, 0, 0, 797, 800, 1, 0, 0, 0, 798, 796, 1,
    0, 0, 0, 798, 799, 1, 0, 0, 0, 799, 802, 1, 0, 0, 0, 800, 798, 1, 0, 0, 0, 801, 803, 3, 66, 33, 0,
    802, 801, 1, 0, 0, 0, 802, 803, 1, 0, 0, 0, 803, 805, 1, 0, 0, 0, 804, 806, 5, 5, 0, 0, 805, 804,
    1, 0, 0, 0, 805, 806, 1, 0, 0, 0, 806, 85, 1, 0, 0, 0, 807, 808, 5, 1, 0, 0, 808, 809, 3, 6, 3, 0,
    809, 810, 5, 2, 0, 0, 810, 814, 3, 6, 3, 0, 811, 813, 3, 64, 32, 0, 812, 811, 1, 0, 0, 0, 813, 816,
    1, 0, 0, 0, 814, 812, 1, 0, 0, 0, 814, 815, 1, 0, 0, 0, 815, 817, 1, 0, 0, 0, 816, 814, 1, 0, 0, 0,
    817, 818, 5, 4, 0, 0, 818, 820, 3, 6, 3, 0, 819, 821, 3, 6, 3, 0, 820, 819, 1, 0, 0, 0, 820, 821,
    1, 0, 0, 0, 821, 825, 1, 0, 0, 0, 822, 824, 3, 64, 32, 0, 823, 822, 1, 0, 0, 0, 824, 827, 1, 0, 0,
    0, 825, 823, 1, 0, 0, 0, 825, 826, 1, 0, 0, 0, 826, 829, 1, 0, 0, 0, 827, 825, 1, 0, 0, 0, 828, 830,
    3, 66, 33, 0, 829, 828, 1, 0, 0, 0, 829, 830, 1, 0, 0, 0, 830, 832, 1, 0, 0, 0, 831, 833, 5, 5, 0,
    0, 832, 831, 1, 0, 0, 0, 832, 833, 1, 0, 0, 0, 833, 87, 1, 0, 0, 0, 834, 835, 5, 1, 0, 0, 835, 836,
    3, 6, 3, 0, 836, 837, 5, 2, 0, 0, 837, 841, 3, 6, 3, 0, 838, 840, 3, 64, 32, 0, 839, 838, 1, 0, 0,
    0, 840, 843, 1, 0, 0, 0, 841, 839, 1, 0, 0, 0, 841, 842, 1, 0, 0, 0, 842, 844, 1, 0, 0, 0, 843, 841,
    1, 0, 0, 0, 844, 845, 5, 4, 0, 0, 845, 846, 3, 6, 3, 0, 846, 850, 5, 2, 0, 0, 847, 849, 3, 64, 32,
    0, 848, 847, 1, 0, 0, 0, 849, 852, 1, 0, 0, 0, 850, 848, 1, 0, 0, 0, 850, 851, 1, 0, 0, 0, 851, 854,
    1, 0, 0, 0, 852, 850, 1, 0, 0, 0, 853, 855, 3, 66, 33, 0, 854, 853, 1, 0, 0, 0, 854, 855, 1, 0, 0,
    0, 855, 857, 1, 0, 0, 0, 856, 858, 5, 5, 0, 0, 857, 856, 1, 0, 0, 0, 857, 858, 1, 0, 0, 0, 858, 89,
    1, 0, 0, 0, 859, 860, 5, 6, 0, 0, 860, 864, 3, 6, 3, 0, 861, 863, 3, 92, 46, 0, 862, 861, 1, 0, 0,
    0, 863, 866, 1, 0, 0, 0, 864, 862, 1, 0, 0, 0, 864, 865, 1, 0, 0, 0, 865, 868, 1, 0, 0, 0, 866, 864,
    1, 0, 0, 0, 867, 869, 3, 66, 33, 0, 868, 867, 1, 0, 0, 0, 868, 869, 1, 0, 0, 0, 869, 870, 1, 0, 0,
    0, 870, 871, 5, 5, 0, 0, 871, 91, 1, 0, 0, 0, 872, 873, 5, 7, 0, 0, 873, 874, 3, 6, 3, 0, 874, 875,
    5, 2, 0, 0, 875, 876, 3, 6, 3, 0, 876, 93, 1, 0, 0, 0, 877, 884, 3, 96, 48, 0, 878, 884, 3, 98, 49,
    0, 879, 884, 3, 100, 50, 0, 880, 884, 3, 102, 51, 0, 881, 884, 3, 104, 52, 0, 882, 884, 3, 106,
    53, 0, 883, 877, 1, 0, 0, 0, 883, 878, 1, 0, 0, 0, 883, 879, 1, 0, 0, 0, 883, 880, 1, 0, 0, 0, 883,
    881, 1, 0, 0, 0, 883, 882, 1, 0, 0, 0, 884, 95, 1, 0, 0, 0, 885, 886, 5, 6, 0, 0, 886, 97, 1, 0, 0,
    0, 887, 888, 5, 6, 0, 0, 888, 889, 3, 6, 3, 0, 889, 99, 1, 0, 0, 0, 890, 891, 5, 6, 0, 0, 891, 895,
    3, 6, 3, 0, 892, 894, 3, 92, 46, 0, 893, 892, 1, 0, 0, 0, 894, 897, 1, 0, 0, 0, 895, 893, 1, 0, 0,
    0, 895, 896, 1, 0, 0, 0, 896, 898, 1, 0, 0, 0, 897, 895, 1, 0, 0, 0, 898, 899, 5, 7, 0, 0, 899, 101,
    1, 0, 0, 0, 900, 901, 5, 6, 0, 0, 901, 905, 3, 6, 3, 0, 902, 904, 3, 92, 46, 0, 903, 902, 1, 0, 0,
    0, 904, 907, 1, 0, 0, 0, 905, 903, 1, 0, 0, 0, 905, 906, 1, 0, 0, 0, 906, 908, 1, 0, 0, 0, 907, 905,
    1, 0, 0, 0, 908, 909, 5, 7, 0, 0, 909, 910, 3, 6, 3, 0, 910, 103, 1, 0, 0, 0, 911, 912, 5, 6, 0, 0,
    912, 916, 3, 6, 3, 0, 913, 915, 3, 92, 46, 0, 914, 913, 1, 0, 0, 0, 915, 918, 1, 0, 0, 0, 916, 914,
    1, 0, 0, 0, 916, 917, 1, 0, 0, 0, 917, 919, 1, 0, 0, 0, 918, 916, 1, 0, 0, 0, 919, 920, 5, 7, 0, 0,
    920, 921, 3, 6, 3, 0, 921, 922, 5, 2, 0, 0, 922, 105, 1, 0, 0, 0, 923, 924, 5, 6, 0, 0, 924, 928,
    3, 6, 3, 0, 925, 927, 3, 92, 46, 0, 926, 925, 1, 0, 0, 0, 927, 930, 1, 0, 0, 0, 928, 926, 1, 0, 0,
    0, 928, 929, 1, 0, 0, 0, 929, 932, 1, 0, 0, 0, 930, 928, 1, 0, 0, 0, 931, 933, 3, 66, 33, 0, 932,
    931, 1, 0, 0, 0, 932, 933, 1, 0, 0, 0, 933, 107, 1, 0, 0, 0, 934, 940, 3, 112, 56, 0, 935, 936,
    5, 38, 0, 0, 936, 937, 3, 112, 56, 0, 937, 938, 5, 39, 0, 0, 938, 940, 1, 0, 0, 0, 939, 934, 1,
    0, 0, 0, 939, 935, 1, 0, 0, 0, 940, 109, 1, 0, 0, 0, 941, 947, 3, 116, 58, 0, 942, 943, 5, 38, 0,
    0, 943, 944, 3, 116, 58, 0, 944, 945, 5, 39, 0, 0, 945, 947, 1, 0, 0, 0, 946, 941, 1, 0, 0, 0, 946,
    942, 1, 0, 0, 0, 947, 111, 1, 0, 0, 0, 948, 949, 7, 4, 0, 0, 949, 113, 1, 0, 0, 0, 950, 951, 7, 5,
    0, 0, 951, 115, 1, 0, 0, 0, 952, 953, 5, 23, 0, 0, 953, 955, 5, 38, 0, 0, 954, 956, 3, 118, 59,
    0, 955, 954, 1, 0, 0, 0, 955, 956, 1, 0, 0, 0, 956, 957, 1, 0, 0, 0, 957, 958, 5, 39, 0, 0, 958,
    117, 1, 0, 0, 0, 959, 964, 3, 6, 3, 0, 960, 961, 5, 40, 0, 0, 961, 963, 3, 6, 3, 0, 962, 960, 1,
    0, 0, 0, 963, 966, 1, 0, 0, 0, 964, 962, 1, 0, 0, 0, 964, 965, 1, 0, 0, 0, 965, 119, 1, 0, 0, 0, 966,
    964, 1, 0, 0, 0, 967, 968, 3, 122, 61, 0, 968, 121, 1, 0, 0, 0, 969, 970, 5, 23, 0, 0, 970, 972,
    5, 38, 0, 0, 971, 973, 3, 118, 59, 0, 972, 971, 1, 0, 0, 0, 972, 973, 1, 0, 0, 0, 973, 123, 1, 0,
    0, 0, 974, 981, 3, 126, 63, 0, 975, 981, 3, 128, 64, 0, 976, 981, 3, 130, 65, 0, 977, 981, 3,
    132, 66, 0, 978, 981, 3, 134, 67, 0, 979, 981, 3, 136, 68, 0, 980, 974, 1, 0, 0, 0, 980, 975,
    1, 0, 0, 0, 980, 976, 1, 0, 0, 0, 980, 977, 1, 0, 0, 0, 980, 978, 1, 0, 0, 0, 980, 979, 1, 0, 0, 0,
    981, 125, 1, 0, 0, 0, 982, 983, 5, 31, 0, 0, 983, 127, 1, 0, 0, 0, 984, 985, 5, 29, 0, 0, 985, 129,
    1, 0, 0, 0, 986, 987, 5, 33, 0, 0, 987, 131, 1, 0, 0, 0, 988, 989, 5, 34, 0, 0, 989, 133, 1, 0, 0,
    0, 990, 991, 7, 6, 0, 0, 991, 135, 1, 0, 0, 0, 992, 993, 5, 10, 0, 0, 993, 137, 1, 0, 0, 0, 994,
    997, 3, 140, 70, 0, 995, 997, 3, 142, 71, 0, 996, 994, 1, 0, 0, 0, 996, 995, 1, 0, 0, 0, 997, 139,
    1, 0, 0, 0, 998, 999, 5, 32, 0, 0, 999, 141, 1, 0, 0, 0, 1000, 1001, 5, 30, 0, 0, 1001, 143, 1,
    0, 0, 0, 115, 150, 164, 170, 196, 221, 223, 228, 275, 293, 295, 314, 320, 327, 334, 348, 351,
    354, 357, 362, 365, 368, 374, 377, 384, 392, 401, 413, 416, 419, 422, 427, 430, 433, 439,
    442, 449, 457, 465, 472, 478, 494, 507, 514, 522, 525, 536, 539, 552, 555, 566, 569, 582,
    585, 593, 602, 608, 625, 629, 651, 655, 658, 663, 667, 670, 675, 680, 684, 687, 695, 699,
    702, 711, 715, 718, 727, 732, 741, 745, 754, 758, 761, 764, 769, 773, 776, 785, 790, 793,
    798, 802, 805, 814, 820, 825, 829, 832, 841, 850, 854, 857, 864, 868, 883, 895, 905, 916,
    928, 932, 939, 946, 955, 964, 972, 980, 996];
TableauExpressionParser.DecisionsToDFA = TableauExpressionParser._ATN.decisionToState.map((ds, index) => new DFA(ds, index));
export class ExpressionEOFContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    expression() {
        return this.getTypedRuleContext(ExpressionContext, 0);
    }
    EOF() {
        return this.getToken(TableauExpressionParser.EOF, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_expressionEOF;
    }
    enterRule(listener) {
        if (listener.enterExpressionEOF) {
            listener.enterExpressionEOF(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpressionEOF) {
            listener.exitExpressionEOF(this);
        }
    }
}
export class ExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    lodExpression() {
        return this.getTypedRuleContext(LodExpressionContext, 0);
    }
    analyticsExpression() {
        return this.getTypedRuleContext(AnalyticsExpressionContext, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_expression;
    }
    enterRule(listener) {
        if (listener.enterExpression) {
            listener.enterExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpression) {
            listener.exitExpression(this);
        }
    }
}
export class LodExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    lodStatement() {
        return this.getTypedRuleContext(LodStatementContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    lodExpression() {
        return this.getTypedRuleContext(LodExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    lodStatementIncomplete() {
        return this.getTypedRuleContext(LodStatementIncompleteContext, 0);
    }
    lodStatementUnsupported() {
        return this.getTypedRuleContext(LodStatementUnsupportedContext, 0);
    }
    comment() {
        return this.getTypedRuleContext(CommentContext, 0);
    }
    lodStatementNestedExpressions() {
        return this.getTypedRuleContext(LodStatementNestedExpressionsContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodExpression;
    }
    enterRule(listener) {
        if (listener.enterLodExpression) {
            listener.enterLodExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodExpression) {
            listener.exitLodExpression(this);
        }
    }
}
export class ScalarExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_scalarExpression;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class NegationExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    MINUS() {
        return this.getToken(TableauExpressionParser.MINUS, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterNegationExpression) {
            listener.enterNegationExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNegationExpression) {
            listener.exitNegationExpression(this);
        }
    }
}
export class LodStatementNotTopLevelContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    lodExpression() {
        return this.getTypedRuleContext(LodExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterLodStatementNotTopLevel) {
            listener.enterLodStatementNotTopLevel(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementNotTopLevel) {
            listener.exitLodStatementNotTopLevel(this);
        }
    }
}
export class ExponentExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    EXPONENT() {
        return this.getToken(TableauExpressionParser.EXPONENT, 0);
    }
    enterRule(listener) {
        if (listener.enterExponentExpression) {
            listener.enterExponentExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExponentExpression) {
            listener.exitExponentExpression(this);
        }
    }
}
export class FieldExpressionIncompleteContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    fieldReferenceIncomplete() {
        return this.getTypedRuleContext(FieldReferenceIncompleteContext, 0);
    }
    enterRule(listener) {
        if (listener.enterFieldExpressionIncomplete) {
            listener.enterFieldExpressionIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFieldExpressionIncomplete) {
            listener.exitFieldExpressionIncomplete(this);
        }
    }
}
export class MultDivExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    multDivOps() {
        return this.getTypedRuleContext(MultDivOpsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterMultDivExpression) {
            listener.enterMultDivExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMultDivExpression) {
            listener.exitMultDivExpression(this);
        }
    }
}
export class NotExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    NOT() {
        return this.getToken(TableauExpressionParser.NOT, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterNotExpression) {
            listener.enterNotExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNotExpression) {
            listener.exitNotExpression(this);
        }
    }
}
export class ComparisonExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    comparisonOps() {
        return this.getTypedRuleContext(ComparisonOpsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterComparisonExpression) {
            listener.enterComparisonExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitComparisonExpression) {
            listener.exitComparisonExpression(this);
        }
    }
}
export class ExpressionCommentContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    comment() {
        return this.getTypedRuleContext(CommentContext, 0);
    }
    enterRule(listener) {
        if (listener.enterExpressionComment) {
            listener.enterExpressionComment(this);
        }
    }
    exitRule(listener) {
        if (listener.exitExpressionComment) {
            listener.exitExpressionComment(this);
        }
    }
}
export class CaseExpressionIncompleteContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    caseStatementIncomplete() {
        return this.getTypedRuleContext(CaseStatementIncompleteContext, 0);
    }
    enterRule(listener) {
        if (listener.enterCaseExpressionIncomplete) {
            listener.enterCaseExpressionIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseExpressionIncomplete) {
            listener.exitCaseExpressionIncomplete(this);
        }
    }
}
export class FunctionExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    enterRule(listener) {
        if (listener.enterFunctionExpression) {
            listener.enterFunctionExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionExpression) {
            listener.exitFunctionExpression(this);
        }
    }
}
export class FunctionExpressionIncompleteContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    functionCallIncomplete() {
        return this.getTypedRuleContext(FunctionCallIncompleteContext, 0);
    }
    enterRule(listener) {
        if (listener.enterFunctionExpressionIncomplete) {
            listener.enterFunctionExpressionIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionExpressionIncomplete) {
            listener.exitFunctionExpressionIncomplete(this);
        }
    }
}
export class OrExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    OR() {
        return this.getToken(TableauExpressionParser.OR, 0);
    }
    enterRule(listener) {
        if (listener.enterOrExpression) {
            listener.enterOrExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrExpression) {
            listener.exitOrExpression(this);
        }
    }
}
export class GroupingExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    enterRule(listener) {
        if (listener.enterGroupingExpression) {
            listener.enterGroupingExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitGroupingExpression) {
            listener.exitGroupingExpression(this);
        }
    }
}
export class AndExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    AND() {
        return this.getToken(TableauExpressionParser.AND, 0);
    }
    enterRule(listener) {
        if (listener.enterAndExpression) {
            listener.enterAndExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAndExpression) {
            listener.exitAndExpression(this);
        }
    }
}
export class AddSubExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    addSubOps() {
        return this.getTypedRuleContext(AddSubOpsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAddSubExpression) {
            listener.enterAddSubExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAddSubExpression) {
            listener.exitAddSubExpression(this);
        }
    }
}
export class IfExpressionIncompleteContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ifStatementIncomplete() {
        return this.getTypedRuleContext(IfStatementIncompleteContext, 0);
    }
    enterRule(listener) {
        if (listener.enterIfExpressionIncomplete) {
            listener.enterIfExpressionIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfExpressionIncomplete) {
            listener.exitIfExpressionIncomplete(this);
        }
    }
}
export class CommentExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    comment() {
        return this.getTypedRuleContext(CommentContext, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterCommentExpression) {
            listener.enterCommentExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCommentExpression) {
            listener.exitCommentExpression(this);
        }
    }
}
export class CaseExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    caseStatement() {
        return this.getTypedRuleContext(CaseStatementContext, 0);
    }
    enterRule(listener) {
        if (listener.enterCaseExpression) {
            listener.enterCaseExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseExpression) {
            listener.exitCaseExpression(this);
        }
    }
}
export class FieldExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    fieldReference() {
        return this.getTypedRuleContext(FieldReferenceContext, 0);
    }
    enterRule(listener) {
        if (listener.enterFieldExpression) {
            listener.enterFieldExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFieldExpression) {
            listener.exitFieldExpression(this);
        }
    }
}
export class IfExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ifStatement() {
        return this.getTypedRuleContext(IfStatementContext, 0);
    }
    enterRule(listener) {
        if (listener.enterIfExpression) {
            listener.enterIfExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfExpression) {
            listener.exitIfExpression(this);
        }
    }
}
export class LiteralExpressionContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    literal() {
        return this.getTypedRuleContext(LiteralContext, 0);
    }
    enterRule(listener) {
        if (listener.enterLiteralExpression) {
            listener.enterLiteralExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLiteralExpression) {
            listener.exitLiteralExpression(this);
        }
    }
}
export class LiteralExpressionIncompleteContext extends ScalarExpressionContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    literalIncomplete() {
        return this.getTypedRuleContext(LiteralIncompleteContext, 0);
    }
    enterRule(listener) {
        if (listener.enterLiteralExpressionIncomplete) {
            listener.enterLiteralExpressionIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLiteralExpressionIncomplete) {
            listener.exitLiteralExpressionIncomplete(this);
        }
    }
}
export class ValidAnalyticsExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    partitionExpression() {
        return this.getTypedRuleContext(PartitionExpressionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_validAnalyticsExpression;
    }
    enterRule(listener) {
        if (listener.enterValidAnalyticsExpression) {
            listener.enterValidAnalyticsExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitValidAnalyticsExpression) {
            listener.exitValidAnalyticsExpression(this);
        }
    }
}
export class MultipleValidAnalyticsExpressionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_multipleValidAnalyticsExpressions;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class AddSubExpressionAnalyticContext extends MultipleValidAnalyticsExpressionsContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    validAnalyticsExpression_list() {
        return this.getTypedRuleContexts(ValidAnalyticsExpressionContext);
    }
    validAnalyticsExpression(i) {
        return this.getTypedRuleContext(ValidAnalyticsExpressionContext, i);
    }
    addSubOps() {
        return this.getTypedRuleContext(AddSubOpsContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    multipleValidAnalyticsExpressions() {
        return this.getTypedRuleContext(MultipleValidAnalyticsExpressionsContext, 0);
    }
    enterRule(listener) {
        if (listener.enterAddSubExpressionAnalytic) {
            listener.enterAddSubExpressionAnalytic(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAddSubExpressionAnalytic) {
            listener.exitAddSubExpressionAnalytic(this);
        }
    }
}
export class MultDivExpressionAnalyticContext extends MultipleValidAnalyticsExpressionsContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    validAnalyticsExpression_list() {
        return this.getTypedRuleContexts(ValidAnalyticsExpressionContext);
    }
    validAnalyticsExpression(i) {
        return this.getTypedRuleContext(ValidAnalyticsExpressionContext, i);
    }
    multDivOps() {
        return this.getTypedRuleContext(MultDivOpsContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    multipleValidAnalyticsExpressions() {
        return this.getTypedRuleContext(MultipleValidAnalyticsExpressionsContext, 0);
    }
    floatLiteral() {
        return this.getTypedRuleContext(FloatLiteralContext, 0);
    }
    integerLiteral() {
        return this.getTypedRuleContext(IntegerLiteralContext, 0);
    }
    enterRule(listener) {
        if (listener.enterMultDivExpressionAnalytic) {
            listener.enterMultDivExpressionAnalytic(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMultDivExpressionAnalytic) {
            listener.exitMultDivExpressionAnalytic(this);
        }
    }
}
export class AnalyticsExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    validAnalyticsExpression() {
        return this.getTypedRuleContext(ValidAnalyticsExpressionContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    analyticsExpression() {
        return this.getTypedRuleContext(AnalyticsExpressionContext, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    orderbyExpressionIncomplete() {
        return this.getTypedRuleContext(OrderbyExpressionIncompleteContext, 0);
    }
    partitionExpressionIncomplete() {
        return this.getTypedRuleContext(PartitionExpressionIncompleteContext, 0);
    }
    comment() {
        return this.getTypedRuleContext(CommentContext, 0);
    }
    multipleValidAnalyticsExpressions() {
        return this.getTypedRuleContext(MultipleValidAnalyticsExpressionsContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_analyticsExpression;
    }
    enterRule(listener) {
        if (listener.enterAnalyticsExpression) {
            listener.enterAnalyticsExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAnalyticsExpression) {
            listener.exitAnalyticsExpression(this);
        }
    }
}
export class OrderbyDirectionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ASC() {
        return this.getToken(TableauExpressionParser.ASC, 0);
    }
    DESC() {
        return this.getToken(TableauExpressionParser.DESC, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyDirection;
    }
    enterRule(listener) {
        if (listener.enterOrderbyDirection) {
            listener.enterOrderbyDirection(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyDirection) {
            listener.exitOrderbyDirection(this);
        }
    }
}
export class OrderbyColumnContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    multiRowFieldReference() {
        return this.getTypedRuleContext(MultiRowFieldReferenceContext, 0);
    }
    orderbyDirection() {
        return this.getTypedRuleContext(OrderbyDirectionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyColumn;
    }
    enterRule(listener) {
        if (listener.enterOrderbyColumn) {
            listener.enterOrderbyColumn(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyColumn) {
            listener.exitOrderbyColumn(this);
        }
    }
}
export class OrderbyColumnsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    orderbyColumn_list() {
        return this.getTypedRuleContexts(OrderbyColumnContext);
    }
    orderbyColumn(i) {
        return this.getTypedRuleContext(OrderbyColumnContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyColumns;
    }
    enterRule(listener) {
        if (listener.enterOrderbyColumns) {
            listener.enterOrderbyColumns(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyColumns) {
            listener.exitOrderbyColumns(this);
        }
    }
}
export class OrderbyAnalyticsFunctionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    multiRowFunctionCall() {
        return this.getTypedRuleContext(MultiRowFunctionCallContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyAnalyticsFunction;
    }
    enterRule(listener) {
        if (listener.enterOrderbyAnalyticsFunction) {
            listener.enterOrderbyAnalyticsFunction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyAnalyticsFunction) {
            listener.exitOrderbyAnalyticsFunction(this);
        }
    }
}
export class OrderbyExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    orderbyColumns() {
        return this.getTypedRuleContext(OrderbyColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyAnalyticsFunction() {
        return this.getTypedRuleContext(OrderbyAnalyticsFunctionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyExpression;
    }
    enterRule(listener) {
        if (listener.enterOrderbyExpression) {
            listener.enterOrderbyExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyExpression) {
            listener.exitOrderbyExpression(this);
        }
    }
}
export class OrderbyExpressionIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_orderbyExpressionIncomplete;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class OrderbyMissingEndBracketContext extends OrderbyExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    orderbyColumns() {
        return this.getTypedRuleContext(OrderbyColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyAnalyticsFunction() {
        return this.getTypedRuleContext(OrderbyAnalyticsFunctionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterOrderbyMissingEndBracket) {
            listener.enterOrderbyMissingEndBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyMissingEndBracket) {
            listener.exitOrderbyMissingEndBracket(this);
        }
    }
}
export class OrderbyMissingOrderContext extends OrderbyExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyAnalyticsFunction() {
        return this.getTypedRuleContext(OrderbyAnalyticsFunctionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterOrderbyMissingOrder) {
            listener.enterOrderbyMissingOrder(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyMissingOrder) {
            listener.exitOrderbyMissingOrder(this);
        }
    }
}
export class OrderbyMissingStartBracketContext extends OrderbyExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    orderbyColumns() {
        return this.getTypedRuleContext(OrderbyColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyAnalyticsFunction() {
        return this.getTypedRuleContext(OrderbyAnalyticsFunctionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterOrderbyMissingStartBracket) {
            listener.enterOrderbyMissingStartBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyMissingStartBracket) {
            listener.exitOrderbyMissingStartBracket(this);
        }
    }
}
export class OrderbyMissingColonContext extends OrderbyExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    orderbyColumns() {
        return this.getTypedRuleContext(OrderbyColumnsContext, 0);
    }
    orderbyAnalyticsFunction() {
        return this.getTypedRuleContext(OrderbyAnalyticsFunctionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterOrderbyMissingColon) {
            listener.enterOrderbyMissingColon(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyMissingColon) {
            listener.exitOrderbyMissingColon(this);
        }
    }
}
export class OrderbyMissingFunctionContext extends OrderbyExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    ORDERBY() {
        return this.getToken(TableauExpressionParser.ORDERBY, 0);
    }
    orderbyColumns() {
        return this.getTypedRuleContext(OrderbyColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterOrderbyMissingFunction) {
            listener.enterOrderbyMissingFunction(this);
        }
    }
    exitRule(listener) {
        if (listener.exitOrderbyMissingFunction) {
            listener.exitOrderbyMissingFunction(this);
        }
    }
}
export class PartitionByColumnContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    multiRowFieldReference() {
        return this.getTypedRuleContext(MultiRowFieldReferenceContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_partitionByColumn;
    }
    enterRule(listener) {
        if (listener.enterPartitionByColumn) {
            listener.enterPartitionByColumn(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionByColumn) {
            listener.exitPartitionByColumn(this);
        }
    }
}
export class PartitionByColumnsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    partitionByColumn() {
        return this.getTypedRuleContext(PartitionByColumnContext, 0);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    partitionByColumns_list() {
        return this.getTypedRuleContexts(PartitionByColumnsContext);
    }
    partitionByColumns(i) {
        return this.getTypedRuleContext(PartitionByColumnsContext, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_partitionByColumns;
    }
    enterRule(listener) {
        if (listener.enterPartitionByColumns) {
            listener.enterPartitionByColumns(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionByColumns) {
            listener.exitPartitionByColumns(this);
        }
    }
}
export class PartitionExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_partitionExpression;
    }
    enterRule(listener) {
        if (listener.enterPartitionExpression) {
            listener.enterPartitionExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionExpression) {
            listener.exitPartitionExpression(this);
        }
    }
}
export class PartitionExpressionIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_partitionExpressionIncomplete;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
export class PartitionMissingPartitionsContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionMissingPartitions) {
            listener.enterPartitionMissingPartitions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionMissingPartitions) {
            listener.exitPartitionMissingPartitions(this);
        }
    }
}
export class PartitionMissingEndBracketContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionMissingEndBracket) {
            listener.enterPartitionMissingEndBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionMissingEndBracket) {
            listener.exitPartitionMissingEndBracket(this);
        }
    }
}
export class PartitionInvalidOrderbyContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyExpressionIncomplete() {
        return this.getTypedRuleContext(OrderbyExpressionIncompleteContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionInvalidOrderby) {
            listener.enterPartitionInvalidOrderby(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionInvalidOrderby) {
            listener.exitPartitionInvalidOrderby(this);
        }
    }
}
export class PartitionMissingColonContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionMissingColon) {
            listener.enterPartitionMissingColon(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionMissingColon) {
            listener.exitPartitionMissingColon(this);
        }
    }
}
export class PartitionMissingOrderbyContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionMissingOrderby) {
            listener.enterPartitionMissingOrderby(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionMissingOrderby) {
            listener.exitPartitionMissingOrderby(this);
        }
    }
}
export class PartitionMissingStartBracketContext extends PartitionExpressionIncompleteContext {
    constructor(parser, ctx) {
        super(parser, ctx.parentCtx, ctx.invokingState);
        super.copyFrom(ctx);
    }
    PARTITION() {
        return this.getToken(TableauExpressionParser.PARTITION, 0);
    }
    partitionByColumns() {
        return this.getTypedRuleContext(PartitionByColumnsContext, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    orderbyExpression() {
        return this.getTypedRuleContext(OrderbyExpressionContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    enterRule(listener) {
        if (listener.enterPartitionMissingStartBracket) {
            listener.enterPartitionMissingStartBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitPartitionMissingStartBracket) {
            listener.exitPartitionMissingStartBracket(this);
        }
    }
}
export class LodGroupByContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    multiRowFieldReference() {
        return this.getTypedRuleContext(MultiRowFieldReferenceContext, 0);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    lodGroupBy_list() {
        return this.getTypedRuleContexts(LodGroupByContext);
    }
    lodGroupBy(i) {
        return this.getTypedRuleContext(LodGroupByContext, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodGroupBy;
    }
    enterRule(listener) {
        if (listener.enterLodGroupBy) {
            listener.enterLodGroupBy(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodGroupBy) {
            listener.exitLodGroupBy(this);
        }
    }
}
export class LodStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    multiRowFunctionCall() {
        return this.getTypedRuleContext(MultiRowFunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    lodGroupBy() {
        return this.getTypedRuleContext(LodGroupByContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatement;
    }
    enterRule(listener) {
        if (listener.enterLodStatement) {
            listener.enterLodStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatement) {
            listener.exitLodStatement(this);
        }
    }
}
export class LodStatementNestedExpressionsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    expression_list() {
        return this.getTypedRuleContexts(ExpressionContext);
    }
    expression(i) {
        return this.getTypedRuleContext(ExpressionContext, i);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    lodGroupBy() {
        return this.getTypedRuleContext(LodGroupByContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementNestedExpressions;
    }
    enterRule(listener) {
        if (listener.enterLodStatementNestedExpressions) {
            listener.enterLodStatementNestedExpressions(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementNestedExpressions) {
            listener.exitLodStatementNestedExpressions(this);
        }
    }
}
export class LodStatementIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    lodStatementMissingBrackets() {
        return this.getTypedRuleContext(LodStatementMissingBracketsContext, 0);
    }
    lodStatementMissingLeftBracket() {
        return this.getTypedRuleContext(LodStatementMissingLeftBracketContext, 0);
    }
    lodStatementMissingRightBracket() {
        return this.getTypedRuleContext(LodStatementMissingRightBracketContext, 0);
    }
    lodStatementMissingFixed() {
        return this.getTypedRuleContext(LodStatementMissingFixedContext, 0);
    }
    lodStatementMissingColon() {
        return this.getTypedRuleContext(LodStatementMissingColonContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementIncomplete;
    }
    enterRule(listener) {
        if (listener.enterLodStatementIncomplete) {
            listener.enterLodStatementIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementIncomplete) {
            listener.exitLodStatementIncomplete(this);
        }
    }
}
export class LodStatementMissingBracketsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    fieldReference_list() {
        return this.getTypedRuleContexts(FieldReferenceContext);
    }
    fieldReference(i) {
        return this.getTypedRuleContext(FieldReferenceContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementMissingBrackets;
    }
    enterRule(listener) {
        if (listener.enterLodStatementMissingBrackets) {
            listener.enterLodStatementMissingBrackets(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementMissingBrackets) {
            listener.exitLodStatementMissingBrackets(this);
        }
    }
}
export class LodStatementMissingLeftBracketContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    fieldReference_list() {
        return this.getTypedRuleContexts(FieldReferenceContext);
    }
    fieldReference(i) {
        return this.getTypedRuleContext(FieldReferenceContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementMissingLeftBracket;
    }
    enterRule(listener) {
        if (listener.enterLodStatementMissingLeftBracket) {
            listener.enterLodStatementMissingLeftBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementMissingLeftBracket) {
            listener.exitLodStatementMissingLeftBracket(this);
        }
    }
}
export class LodStatementMissingRightBracketContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    fieldReference_list() {
        return this.getTypedRuleContexts(FieldReferenceContext);
    }
    fieldReference(i) {
        return this.getTypedRuleContext(FieldReferenceContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementMissingRightBracket;
    }
    enterRule(listener) {
        if (listener.enterLodStatementMissingRightBracket) {
            listener.enterLodStatementMissingRightBracket(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementMissingRightBracket) {
            listener.exitLodStatementMissingRightBracket(this);
        }
    }
}
export class LodStatementMissingFixedContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    fieldReference_list() {
        return this.getTypedRuleContexts(FieldReferenceContext);
    }
    fieldReference(i) {
        return this.getTypedRuleContext(FieldReferenceContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementMissingFixed;
    }
    enterRule(listener) {
        if (listener.enterLodStatementMissingFixed) {
            listener.enterLodStatementMissingFixed(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementMissingFixed) {
            listener.exitLodStatementMissingFixed(this);
        }
    }
}
export class LodStatementMissingColonContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    FIXED() {
        return this.getToken(TableauExpressionParser.FIXED, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    fieldReference_list() {
        return this.getTypedRuleContexts(FieldReferenceContext);
    }
    fieldReference(i) {
        return this.getTypedRuleContext(FieldReferenceContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementMissingColon;
    }
    enterRule(listener) {
        if (listener.enterLodStatementMissingColon) {
            listener.enterLodStatementMissingColon(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementMissingColon) {
            listener.exitLodStatementMissingColon(this);
        }
    }
}
export class LodStatementUnsupportedContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LCBRACK() {
        return this.getToken(TableauExpressionParser.LCBRACK, 0);
    }
    COLON() {
        return this.getToken(TableauExpressionParser.COLON, 0);
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    RCBRACK() {
        return this.getToken(TableauExpressionParser.RCBRACK, 0);
    }
    INCLUDE() {
        return this.getToken(TableauExpressionParser.INCLUDE, 0);
    }
    lodGroupBy() {
        return this.getTypedRuleContext(LodGroupByContext, 0);
    }
    EXCLUDE() {
        return this.getToken(TableauExpressionParser.EXCLUDE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_lodStatementUnsupported;
    }
    enterRule(listener) {
        if (listener.enterLodStatementUnsupported) {
            listener.enterLodStatementUnsupported(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLodStatementUnsupported) {
            listener.exitLodStatementUnsupported(this);
        }
    }
}
export class CommentContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    COMMENT() {
        return this.getToken(TableauExpressionParser.COMMENT, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_comment;
    }
    enterRule(listener) {
        if (listener.enterComment) {
            listener.enterComment(this);
        }
    }
    exitRule(listener) {
        if (listener.exitComment) {
            listener.exitComment(this);
        }
    }
}
export class MultDivOpsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DIVIDE() {
        return this.getToken(TableauExpressionParser.DIVIDE, 0);
    }
    MULTIPLY() {
        return this.getToken(TableauExpressionParser.MULTIPLY, 0);
    }
    MOD() {
        return this.getToken(TableauExpressionParser.MOD, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_multDivOps;
    }
    enterRule(listener) {
        if (listener.enterMultDivOps) {
            listener.enterMultDivOps(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMultDivOps) {
            listener.exitMultDivOps(this);
        }
    }
}
export class AddSubOpsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    PLUS() {
        return this.getToken(TableauExpressionParser.PLUS, 0);
    }
    MINUS() {
        return this.getToken(TableauExpressionParser.MINUS, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_addSubOps;
    }
    enterRule(listener) {
        if (listener.enterAddSubOps) {
            listener.enterAddSubOps(this);
        }
    }
    exitRule(listener) {
        if (listener.exitAddSubOps) {
            listener.exitAddSubOps(this);
        }
    }
}
export class ComparisonOpsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    GT() {
        return this.getToken(TableauExpressionParser.GT, 0);
    }
    LT() {
        return this.getToken(TableauExpressionParser.LT, 0);
    }
    GTE() {
        return this.getToken(TableauExpressionParser.GTE, 0);
    }
    LTE() {
        return this.getToken(TableauExpressionParser.LTE, 0);
    }
    EQ() {
        return this.getToken(TableauExpressionParser.EQ, 0);
    }
    NEQ() {
        return this.getToken(TableauExpressionParser.NEQ, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_comparisonOps;
    }
    enterRule(listener) {
        if (listener.enterComparisonOps) {
            listener.enterComparisonOps(this);
        }
    }
    exitRule(listener) {
        if (listener.exitComparisonOps) {
            listener.exitComparisonOps(this);
        }
    }
}
export class IfStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatement;
    }
    enterRule(listener) {
        if (listener.enterIfStatement) {
            listener.enterIfStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatement) {
            listener.exitIfStatement(this);
        }
    }
}
export class ElseIfStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ELSEIF() {
        return this.getToken(TableauExpressionParser.ELSEIF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_elseIfStatement;
    }
    enterRule(listener) {
        if (listener.enterElseIfStatement) {
            listener.enterElseIfStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitElseIfStatement) {
            listener.exitElseIfStatement(this);
        }
    }
}
export class ElseStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ELSE() {
        return this.getToken(TableauExpressionParser.ELSE, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_elseStatement;
    }
    enterRule(listener) {
        if (listener.enterElseStatement) {
            listener.enterElseStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitElseStatement) {
            listener.exitElseStatement(this);
        }
    }
}
export class IfStatementIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    ifStatementMissingCondition() {
        return this.getTypedRuleContext(IfStatementMissingConditionContext, 0);
    }
    ifStatementMissingThen() {
        return this.getTypedRuleContext(IfStatementMissingThenContext, 0);
    }
    ifStatementMissingThenExpression() {
        return this.getTypedRuleContext(IfStatementMissingThenExpressionContext, 0);
    }
    ifStatementMissingEnd() {
        return this.getTypedRuleContext(IfStatementMissingEndContext, 0);
    }
    ifStatementMissingElse() {
        return this.getTypedRuleContext(IfStatementMissingElseContext, 0);
    }
    ifStatementMissingElseExpression() {
        return this.getTypedRuleContext(IfStatementMissingElseExpressionContext, 0);
    }
    ifStatementMissingElseIf() {
        return this.getTypedRuleContext(IfStatementMissingElseIfContext, 0);
    }
    ifStatementMissingElseIfCondition() {
        return this.getTypedRuleContext(IfStatementMissingElseIfConditionContext, 0);
    }
    ifStatementMissingElseIfThen() {
        return this.getTypedRuleContext(IfStatementMissingElseIfThenContext, 0);
    }
    ifStatementMissingElseIfThenExpression() {
        return this.getTypedRuleContext(IfStatementMissingElseIfThenExpressionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementIncomplete;
    }
    enterRule(listener) {
        if (listener.enterIfStatementIncomplete) {
            listener.enterIfStatementIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementIncomplete) {
            listener.exitIfStatementIncomplete(this);
        }
    }
}
export class IfStatementMissingConditionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingCondition;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingCondition) {
            listener.enterIfStatementMissingCondition(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingCondition) {
            listener.exitIfStatementMissingCondition(this);
        }
    }
}
export class IfStatementMissingThenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingThen;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingThen) {
            listener.enterIfStatementMissingThen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingThen) {
            listener.exitIfStatementMissingThen(this);
        }
    }
}
export class IfStatementMissingThenExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingThenExpression;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingThenExpression) {
            listener.enterIfStatementMissingThenExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingThenExpression) {
            listener.exitIfStatementMissingThenExpression(this);
        }
    }
}
export class IfStatementMissingElseContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElse;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElse) {
            listener.enterIfStatementMissingElse(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElse) {
            listener.exitIfStatementMissingElse(this);
        }
    }
}
export class IfStatementMissingElseExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    ELSE() {
        return this.getToken(TableauExpressionParser.ELSE, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElseExpression;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElseExpression) {
            listener.enterIfStatementMissingElseExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElseExpression) {
            listener.exitIfStatementMissingElseExpression(this);
        }
    }
}
export class IfStatementMissingEndContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingEnd;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingEnd) {
            listener.enterIfStatementMissingEnd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingEnd) {
            listener.exitIfStatementMissingEnd(this);
        }
    }
}
export class IfStatementMissingElseIfContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN_list() {
        return this.getTokens(TableauExpressionParser.THEN);
    }
    THEN(i) {
        return this.getToken(TableauExpressionParser.THEN, i);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElseIf;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElseIf) {
            listener.enterIfStatementMissingElseIf(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElseIf) {
            listener.exitIfStatementMissingElseIf(this);
        }
    }
}
export class IfStatementMissingElseIfConditionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN_list() {
        return this.getTokens(TableauExpressionParser.THEN);
    }
    THEN(i) {
        return this.getToken(TableauExpressionParser.THEN, i);
    }
    ELSEIF() {
        return this.getToken(TableauExpressionParser.ELSEIF, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElseIfCondition;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElseIfCondition) {
            listener.enterIfStatementMissingElseIfCondition(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElseIfCondition) {
            listener.exitIfStatementMissingElseIfCondition(this);
        }
    }
}
export class IfStatementMissingElseIfThenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    ELSEIF() {
        return this.getToken(TableauExpressionParser.ELSEIF, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElseIfThen;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElseIfThen) {
            listener.enterIfStatementMissingElseIfThen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElseIfThen) {
            listener.exitIfStatementMissingElseIfThen(this);
        }
    }
}
export class IfStatementMissingElseIfThenExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    IF() {
        return this.getToken(TableauExpressionParser.IF, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN_list() {
        return this.getTokens(TableauExpressionParser.THEN);
    }
    THEN(i) {
        return this.getToken(TableauExpressionParser.THEN, i);
    }
    ELSEIF() {
        return this.getToken(TableauExpressionParser.ELSEIF, 0);
    }
    elseIfStatement_list() {
        return this.getTypedRuleContexts(ElseIfStatementContext);
    }
    elseIfStatement(i) {
        return this.getTypedRuleContext(ElseIfStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_ifStatementMissingElseIfThenExpression;
    }
    enterRule(listener) {
        if (listener.enterIfStatementMissingElseIfThenExpression) {
            listener.enterIfStatementMissingElseIfThenExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIfStatementMissingElseIfThenExpression) {
            listener.exitIfStatementMissingElseIfThenExpression(this);
        }
    }
}
export class CaseStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    END() {
        return this.getToken(TableauExpressionParser.END, 0);
    }
    whenStatement_list() {
        return this.getTypedRuleContexts(WhenStatementContext);
    }
    whenStatement(i) {
        return this.getTypedRuleContext(WhenStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatement;
    }
    enterRule(listener) {
        if (listener.enterCaseStatement) {
            listener.enterCaseStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatement) {
            listener.exitCaseStatement(this);
        }
    }
}
export class WhenStatementContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    WHEN() {
        return this.getToken(TableauExpressionParser.WHEN, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_whenStatement;
    }
    enterRule(listener) {
        if (listener.enterWhenStatement) {
            listener.enterWhenStatement(this);
        }
    }
    exitRule(listener) {
        if (listener.exitWhenStatement) {
            listener.exitWhenStatement(this);
        }
    }
}
export class CaseStatementIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    caseStatementMissingCaseExpression() {
        return this.getTypedRuleContext(CaseStatementMissingCaseExpressionContext, 0);
    }
    caseStatementMissingWhen() {
        return this.getTypedRuleContext(CaseStatementMissingWhenContext, 0);
    }
    caseStatementMissingWhenExpression() {
        return this.getTypedRuleContext(CaseStatementMissingWhenExpressionContext, 0);
    }
    caseStatementMissingThen() {
        return this.getTypedRuleContext(CaseStatementMissingThenContext, 0);
    }
    caseStatementMissingThenExpression() {
        return this.getTypedRuleContext(CaseStatementMissingThenExpressionContext, 0);
    }
    caseStatementMissingEnd() {
        return this.getTypedRuleContext(CaseStatementMissingEndContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementIncomplete;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementIncomplete) {
            listener.enterCaseStatementIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementIncomplete) {
            listener.exitCaseStatementIncomplete(this);
        }
    }
}
export class CaseStatementMissingCaseExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingCaseExpression;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingCaseExpression) {
            listener.enterCaseStatementMissingCaseExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingCaseExpression) {
            listener.exitCaseStatementMissingCaseExpression(this);
        }
    }
}
export class CaseStatementMissingWhenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingWhen;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingWhen) {
            listener.enterCaseStatementMissingWhen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingWhen) {
            listener.exitCaseStatementMissingWhen(this);
        }
    }
}
export class CaseStatementMissingWhenExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    WHEN() {
        return this.getToken(TableauExpressionParser.WHEN, 0);
    }
    whenStatement_list() {
        return this.getTypedRuleContexts(WhenStatementContext);
    }
    whenStatement(i) {
        return this.getTypedRuleContext(WhenStatementContext, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingWhenExpression;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingWhenExpression) {
            listener.enterCaseStatementMissingWhenExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingWhenExpression) {
            listener.exitCaseStatementMissingWhenExpression(this);
        }
    }
}
export class CaseStatementMissingThenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    WHEN() {
        return this.getToken(TableauExpressionParser.WHEN, 0);
    }
    whenStatement_list() {
        return this.getTypedRuleContexts(WhenStatementContext);
    }
    whenStatement(i) {
        return this.getTypedRuleContext(WhenStatementContext, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingThen;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingThen) {
            listener.enterCaseStatementMissingThen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingThen) {
            listener.exitCaseStatementMissingThen(this);
        }
    }
}
export class CaseStatementMissingThenExpressionContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    WHEN() {
        return this.getToken(TableauExpressionParser.WHEN, 0);
    }
    THEN() {
        return this.getToken(TableauExpressionParser.THEN, 0);
    }
    whenStatement_list() {
        return this.getTypedRuleContexts(WhenStatementContext);
    }
    whenStatement(i) {
        return this.getTypedRuleContext(WhenStatementContext, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingThenExpression;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingThenExpression) {
            listener.enterCaseStatementMissingThenExpression(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingThenExpression) {
            listener.exitCaseStatementMissingThenExpression(this);
        }
    }
}
export class CaseStatementMissingEndContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    CASE() {
        return this.getToken(TableauExpressionParser.CASE, 0);
    }
    scalarExpression() {
        return this.getTypedRuleContext(ScalarExpressionContext, 0);
    }
    whenStatement_list() {
        return this.getTypedRuleContexts(WhenStatementContext);
    }
    whenStatement(i) {
        return this.getTypedRuleContext(WhenStatementContext, i);
    }
    elseStatement() {
        return this.getTypedRuleContext(ElseStatementContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_caseStatementMissingEnd;
    }
    enterRule(listener) {
        if (listener.enterCaseStatementMissingEnd) {
            listener.enterCaseStatementMissingEnd(this);
        }
    }
    exitRule(listener) {
        if (listener.exitCaseStatementMissingEnd) {
            listener.exitCaseStatementMissingEnd(this);
        }
    }
}
export class MultiRowFieldReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    fieldReference() {
        return this.getTypedRuleContext(FieldReferenceContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_multiRowFieldReference;
    }
    enterRule(listener) {
        if (listener.enterMultiRowFieldReference) {
            listener.enterMultiRowFieldReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMultiRowFieldReference) {
            listener.exitMultiRowFieldReference(this);
        }
    }
}
export class MultiRowFunctionCallContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    functionCall() {
        return this.getTypedRuleContext(FunctionCallContext, 0);
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_multiRowFunctionCall;
    }
    enterRule(listener) {
        if (listener.enterMultiRowFunctionCall) {
            listener.enterMultiRowFunctionCall(this);
        }
    }
    exitRule(listener) {
        if (listener.exitMultiRowFunctionCall) {
            listener.exitMultiRowFunctionCall(this);
        }
    }
}
export class FieldReferenceContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FIELDNAME() {
        return this.getToken(TableauExpressionParser.FIELDNAME, 0);
    }
    IDENTIFIER() {
        return this.getToken(TableauExpressionParser.IDENTIFIER, 0);
    }
    PARAMETER_IN_BRACKETS() {
        return this.getToken(TableauExpressionParser.PARAMETER_IN_BRACKETS, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_fieldReference;
    }
    enterRule(listener) {
        if (listener.enterFieldReference) {
            listener.enterFieldReference(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFieldReference) {
            listener.exitFieldReference(this);
        }
    }
}
export class FieldReferenceIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FIELDNAME_INCOMPLETE() {
        return this.getToken(TableauExpressionParser.FIELDNAME_INCOMPLETE, 0);
    }
    PARAMETER_INCOMPLETE() {
        return this.getToken(TableauExpressionParser.PARAMETER_INCOMPLETE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_fieldReferenceIncomplete;
    }
    enterRule(listener) {
        if (listener.enterFieldReferenceIncomplete) {
            listener.enterFieldReferenceIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFieldReferenceIncomplete) {
            listener.exitFieldReferenceIncomplete(this);
        }
    }
}
export class FunctionCallContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken(TableauExpressionParser.RPAREN, 0);
    }
    IDENTIFIER() {
        return this.getToken(TableauExpressionParser.IDENTIFIER, 0);
    }
    functionArgs() {
        return this.getTypedRuleContext(FunctionArgsContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_functionCall;
    }
    enterRule(listener) {
        if (listener.enterFunctionCall) {
            listener.enterFunctionCall(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionCall) {
            listener.exitFunctionCall(this);
        }
    }
}
export class FunctionArgsContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    scalarExpression_list() {
        return this.getTypedRuleContexts(ScalarExpressionContext);
    }
    scalarExpression(i) {
        return this.getTypedRuleContext(ScalarExpressionContext, i);
    }
    COMMA_list() {
        return this.getTokens(TableauExpressionParser.COMMA);
    }
    COMMA(i) {
        return this.getToken(TableauExpressionParser.COMMA, i);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_functionArgs;
    }
    enterRule(listener) {
        if (listener.enterFunctionArgs) {
            listener.enterFunctionArgs(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionArgs) {
            listener.exitFunctionArgs(this);
        }
    }
}
export class FunctionCallIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    functionCallMissingCloseParen() {
        return this.getTypedRuleContext(FunctionCallMissingCloseParenContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_functionCallIncomplete;
    }
    enterRule(listener) {
        if (listener.enterFunctionCallIncomplete) {
            listener.enterFunctionCallIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionCallIncomplete) {
            listener.exitFunctionCallIncomplete(this);
        }
    }
}
export class FunctionCallMissingCloseParenContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    LPAREN() {
        return this.getToken(TableauExpressionParser.LPAREN, 0);
    }
    IDENTIFIER() {
        return this.getToken(TableauExpressionParser.IDENTIFIER, 0);
    }
    functionArgs() {
        return this.getTypedRuleContext(FunctionArgsContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_functionCallMissingCloseParen;
    }
    enterRule(listener) {
        if (listener.enterFunctionCallMissingCloseParen) {
            listener.enterFunctionCallMissingCloseParen(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFunctionCallMissingCloseParen) {
            listener.exitFunctionCallMissingCloseParen(this);
        }
    }
}
export class LiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    dateLiteral() {
        return this.getTypedRuleContext(DateLiteralContext, 0);
    }
    stringLiteral() {
        return this.getTypedRuleContext(StringLiteralContext, 0);
    }
    integerLiteral() {
        return this.getTypedRuleContext(IntegerLiteralContext, 0);
    }
    floatLiteral() {
        return this.getTypedRuleContext(FloatLiteralContext, 0);
    }
    booleanLiteral() {
        return this.getTypedRuleContext(BooleanLiteralContext, 0);
    }
    nullLiteral() {
        return this.getTypedRuleContext(NullLiteralContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_literal;
    }
    enterRule(listener) {
        if (listener.enterLiteral) {
            listener.enterLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLiteral) {
            listener.exitLiteral(this);
        }
    }
}
export class DateLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATELITERAL() {
        return this.getToken(TableauExpressionParser.DATELITERAL, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_dateLiteral;
    }
    enterRule(listener) {
        if (listener.enterDateLiteral) {
            listener.enterDateLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDateLiteral) {
            listener.exitDateLiteral(this);
        }
    }
}
export class StringLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STRINGLITERAL() {
        return this.getToken(TableauExpressionParser.STRINGLITERAL, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_stringLiteral;
    }
    enterRule(listener) {
        if (listener.enterStringLiteral) {
            listener.enterStringLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringLiteral) {
            listener.exitStringLiteral(this);
        }
    }
}
export class IntegerLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    INTEGER() {
        return this.getToken(TableauExpressionParser.INTEGER, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_integerLiteral;
    }
    enterRule(listener) {
        if (listener.enterIntegerLiteral) {
            listener.enterIntegerLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitIntegerLiteral) {
            listener.exitIntegerLiteral(this);
        }
    }
}
export class FloatLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    FLOAT() {
        return this.getToken(TableauExpressionParser.FLOAT, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_floatLiteral;
    }
    enterRule(listener) {
        if (listener.enterFloatLiteral) {
            listener.enterFloatLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitFloatLiteral) {
            listener.exitFloatLiteral(this);
        }
    }
}
export class BooleanLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    TRUE() {
        return this.getToken(TableauExpressionParser.TRUE, 0);
    }
    FALSE() {
        return this.getToken(TableauExpressionParser.FALSE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_booleanLiteral;
    }
    enterRule(listener) {
        if (listener.enterBooleanLiteral) {
            listener.enterBooleanLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitBooleanLiteral) {
            listener.exitBooleanLiteral(this);
        }
    }
}
export class NullLiteralContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    NULL() {
        return this.getToken(TableauExpressionParser.NULL, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_nullLiteral;
    }
    enterRule(listener) {
        if (listener.enterNullLiteral) {
            listener.enterNullLiteral(this);
        }
    }
    exitRule(listener) {
        if (listener.exitNullLiteral) {
            listener.exitNullLiteral(this);
        }
    }
}
export class LiteralIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    dateLiteralIncomplete() {
        return this.getTypedRuleContext(DateLiteralIncompleteContext, 0);
    }
    stringLiteralIncomplete() {
        return this.getTypedRuleContext(StringLiteralIncompleteContext, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_literalIncomplete;
    }
    enterRule(listener) {
        if (listener.enterLiteralIncomplete) {
            listener.enterLiteralIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitLiteralIncomplete) {
            listener.exitLiteralIncomplete(this);
        }
    }
}
export class DateLiteralIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    DATELITERAL_INCOMPLETE() {
        return this.getToken(TableauExpressionParser.DATELITERAL_INCOMPLETE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_dateLiteralIncomplete;
    }
    enterRule(listener) {
        if (listener.enterDateLiteralIncomplete) {
            listener.enterDateLiteralIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitDateLiteralIncomplete) {
            listener.exitDateLiteralIncomplete(this);
        }
    }
}
export class StringLiteralIncompleteContext extends ParserRuleContext {
    constructor(parser, parent, invokingState) {
        super(parent, invokingState);
        this.parser = parser;
    }
    STRINGLITERAL_INCOMPLETE() {
        return this.getToken(TableauExpressionParser.STRINGLITERAL_INCOMPLETE, 0);
    }
    get ruleIndex() {
        return TableauExpressionParser.RULE_stringLiteralIncomplete;
    }
    enterRule(listener) {
        if (listener.enterStringLiteralIncomplete) {
            listener.enterStringLiteralIncomplete(this);
        }
    }
    exitRule(listener) {
        if (listener.exitStringLiteralIncomplete) {
            listener.exitStringLiteralIncomplete(this);
        }
    }
}
//# sourceMappingURL=TableauExpressionParser.js.map